import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc, apiDocDesc } from '../docHelpers';

const getV12APIs = (userInfo) => {
  return [
    {
      title: '상품리스트 조회',
      url: '/doc/상품리스트 조회',
      data: [
        {
          version: 'v1.2',
          url: '/product/online/list/v1.2',
          desc: apiDocDesc({
            items: [
              '상품 > 상품 관리 리스트를 가져옵니다.',
              '기본 검색은 하나의 검색어만 지원가능합니다.',
              '여러건의 검색을 원하시는경우 멀티검색(multi_search_word)을 이용해 주십시오.',
            ],
          }),
          method: 'POST',
          unrecognized_aff_no: [1057],
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: '검색 시작 값',
            },
            {
              title: 'length',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 상품 갯수', maxValue: '300', defaultValue: '100' }),
            },
            {
              title: 'orderby',
              required: '',
              type: 'String',
              desc: '정렬',
            },
            {
              title: 'search_key',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색 키',
                allowedValues: [
                  ['sku_cd', '<strong>SKU코드</strong>'],
                  ['shop_sale_name', '<strong>온라인 상품명</strong>'],
                  ['c_sale_cd', '<strong>판매자관리코드</strong>'],
                  ['brand_code', '<strong>브랜드코드</strong>'],
                  ['barcode', '<strong>바코드</strong>'],
                  ['global_barcode', '<strong>UPC,EAN 코드</strong>'],
                  ['isbn', '<strong>ISBN코드</strong>'],
                  ['model', '<strong>모델명</strong>'],
                  ['keyword', '<strong>키워드</strong>'],
                  ['shop_sale_no', '<strong>쇼핑몰 상품코드</strong>'],
                  ['memo', '<strong>메모</strong>'],
                  ['std_ol_group_cd', '<strong>그룹상품코드</strong>'],
                  ['shop_promotion_name', '<strong>프로모션용 상품명</strong>'],
                ],
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
            {
              title: 'search_word',
              required: '',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색타입',
                defaultValue: 'partial',
                allowedValues: [['exact', '<strong>완전일치</strong>'], ['partial', '<strong>부분일치</strong>']],
              }),
            },
            {
              title: 'date_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색타입',
                defaultValue: 'wdate',
                allowedValues: [
                  ['wdate', '<strong>등록일</strong>'],
                  ['mdate', '<strong>수정일</strong>'],
                  ['sale_etime', '<strong>판매종료일</strong>'],
                ],
              }),
            },
            {
              title: 'sdate',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '검색시작일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'edate',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '검색종료일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'sol_cate_no',
              required: '',
              type: 'String',
              desc: '솔루션 카테고리 코드',
            },
            {
              title: 'opt_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '옵션 사용여부',
                sub: '["Y: 옵션이 있는 상품만 조회", "N": 옵션이 없는 상품만 조회"]',
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
            {
              title: 'shop_cd',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '쇼핑몰코드',
                sub: [
                  '( 옥션: A001, 지마켓: A006, 11번가: A112, 바이즐: A027... )',
                  '마스터상품 조회시 <strong><code>only_mas</code></strong> 로 입력',
                ],
              }),
            },
            {
              title: 'template_no',
              required: '',
              type: 'String',
              desc: '템플릿코드',
            },
            {
              title: 'addcontent_no',
              required: '',
              type: 'String',
              desc: '머리말/꼬리말 템플릿코드',
            },
            {
              title: 'sale_status',
              required: '',
              type: 'Array',
              desc: apiParamDesc({
                title: '상품 판매 상태',
                allowedValues: ['판매대기', '승인대기', '반려', '판매중', '종료대기', '수정대기', '판매중지', '일시품절'],
              }),
            },
            {
              title: 'depot_no',
              required: '',
              type: 'String',
              desc: '배송처 코드',
            },
            {
              title: 'opt_status',
              required: '',
              type: 'String',
              desc: '옵션 상태',
            },
            {
              title: 'multi_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '멀티검색 키',
                allowedValues: [
                  ['c_sale_cd', '<strong>판매자관리코드</strong>'],
                  ['shop_sale_no', '<strong>쇼핑몰상품코드</strong>'],
                  ['sku_cd', '<strong>SKU코드</strong>'],
                  ['shop', '<strong>쇼핑몰아이디</strong>'],
                ],
              }),
            },
            {
              title: 'multi_search_word',
              required: '',
              type: 'String[]',
              desc: apiParamDesc({
                title: '멀티검색 값',
                sub: 'multi_type이 shop인 경우에는 다음과 같이 설정합니다.(shop_cd|shop_id): ["A001|playauto", "A006|playauto"]',
              }),
            },
            {
              title: 'view_master',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '마스터상품 노출여부 (기본 노출함)', defaultValue: 'true' }),
            },
          ],
          body_example: {
            start: 0,
            length: 100,
            sdate: '2020-07-20',
            edate: '2022-12-31',
            date_type: 'wdate',
            search_key: 'all',
            search_type: 'partial',
            search_word: '',
            orderby: 'wdate desc',
            sale_status: ['판매중'],
            opt_yn: '',
            multi_type: 'c_sale_cd',
            multi_search_word: ['m20220914f60d00d1b', 'm20220902078de3813'],
            view_masteroptional: true,
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object',
              desc: '검색결과는 판매자관리코드로 그룹화되어 판매자관리코드를 키로 가진 배열로 출력됩니다.',
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: '상품고유값',
              indent: 1,
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String(40)',
              desc: '판매자관리코드',
              indent: 1,
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String(4)',
              desc: '쇼핑몰 코드',
              indent: 1,
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String(50)',
              desc: '쇼핑몰 명',
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰 계정 아이디',
              indent: 1,
            },
            {
              title: 'template_no',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({ title: '템플릿 번호', defaultValue: '0' }),
              indent: 1,
            },
            {
              title: 'shop_sale_name_addcontent_no',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({ title: '상품명 머리말/꼬리말 템플릿코드', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'addcontent_no',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({ title: '상세설명 머리말/꼬리말 템플릿코드', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: 'O',
              type: 'String(200)',
              desc: '쇼핑몰상품명',
              indent: 1,
            },
            {
              title: 'sale_status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 판매 상태',
                allowedValues: ['판매대기', '승인대기', '반려', '판매중', '종료대기', '수정대기', '판매중지', '일시품절'],
              }),
              indent: 1,
            },
            {
              title: 'sale_cnt_limit',
              required: 'O',
              type: 'Number(10)',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number(12)',
              desc: '상품 금액',
              indent: 1,
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '상품 원가', defaultValue: '0' }),
              indent: 1,
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '공급가', defaultValue: '0' }),
              indent: 1,
            },
            {
              title: 'street_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '시중가', defaultValue: '0' }),
              indent: 1,
            },
            {
              title: 'opt_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '옵션 타입', allowedValues: ['옵션없음', '조합형', '독립형'] }),
              indent: 1,
            },
            {
              title: 'input_opt_names',
              required: 'O',
              type: 'String[]',
              desc: '입력형옵션',
              indent: 1,
            },
            {
              title: 'tax_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '과세여부', allowedValues: ['과세', '면세', '영세', '비과세'] }),
              indent: 1,
            },
            {
              title: 'ship_price_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '배송비 종류', allowedValues: ['무료', '조건부무료', '착불', '선결제'] }),
              indent: 1,
            },
            {
              title: 'ship_price',
              required: 'O',
              type: 'Number(8)',
              desc: '배송비 금액',
              indent: 1,
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰 판매번호',
              indent: 1,
            },
            {
              title: 'sale_img1',
              required: 'O',
              type: 'String(230)',
              desc: '기본이미지',
              indent: 1,
            },
            {
              title: 'sale_img2',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 1',
              indent: 1,
            },
            {
              title: 'sale_img3',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 2',
              indent: 1,
            },
            {
              title: 'sale_img4',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 3',
              indent: 1,
            },
            {
              title: 'sale_img5',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 4',
              indent: 1,
            },
            {
              title: 'sale_img6',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 5',
              indent: 1,
            },
            {
              title: 'sale_img7',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 6',
              indent: 1,
            },
            {
              title: 'sale_img8',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 7',
              indent: 1,
            },
            {
              title: 'sale_img9',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 8',
              indent: 1,
            },
            {
              title: 'sale_img10',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 9',
              indent: 1,
            },
            {
              title: 'sale_img11',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 10',
              indent: 1,
            },
            {
              title: 'detail_desc',
              required: 'O',
              type: 'String(16777215)',
              desc: '상품 상세설명',
              indent: 1,
            },
            {
              title: 'keywords',
              required: 'O',
              type: 'String[]',
              desc: '키워드',
              indent: 1,
            },
            {
              title: 'model',
              required: 'O',
              type: 'String(50)',
              desc: '모델명',
              indent: 1,
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(50)',
              desc: '모델 번호',
              indent: 1,
            },
            {
              title: 'brand',
              required: 'O',
              type: 'String(50)',
              desc: '브랜드',
              indent: 1,
            },
            {
              title: 'maker',
              required: 'O',
              type: 'String(50)',
              desc: '제조사',
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: apiParamDesc({ title: '상품등록일', sub: '(YYYY-MM-DD HH:mm:ss)' }),
              indent: 1,
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: apiParamDesc({ title: '상품수정일', sub: '(YYYY-MM-DD HH:mm:ss)' }),
              indent: 1,
            },
            {
              title: 'std_ol_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '단일상품 여부', sub: '(0: 일반상품, 1: 단일상품)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'unit_price_yn',
              required: 'O',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 여부',
                allowedValues: ['true', 'false'],
                notes: ['std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'unit_capacity',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 용량',
                notes: [
                  '1 – 999 사이의 정수만 입력 가능합니다.',
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'indication_unit',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 단위',
                allowedValues: [
                  'g',
                  'kg',
                  'ml',
                  'L',
                  'cm',
                  'm',
                  '개',
                  '개입',
                  '매',
                  '매입',
                  '정',
                  '캡슐',
                  '구미',
                  '포',
                  '구',
                ],
                notes: ['unit_price_yn이 true일 때 필수 입력 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 구성 방식',
                allowedValues: ['낱개', '팩'],
                notes: ['unit_price_yn이 true일 때 필수 입력 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_pack_qty',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩 수량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_pack_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_item_qty',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩당 수량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_item_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_item_qty_unit',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩당 수량 단위',
                allowedValues: ['개', '개입', '매입', '매', '병', '캔', '통', '스틱', '알', '정', '캡슐', '구미', '장', '팩', '포'],
                notes: ['지그재그 채널 전송 시에만 사용되는 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'item_capacity',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 개당 용량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '0.001 – 999999999.000 사이의 숫자만 입력 가능합니다. (소수점 셋째자리까지 지원)',
                ],
              }),
              indent: 1,
            },
            {
              title: 'options',
              required: 'O',
              type: 'Object[]',
              desc: apiParamDesc({ title: '옵션', notes: ['옵션없음이라도 SKU상품이 매칭되어있는경우 하나의 데이터가 나옵니다.'] }),
              indent: 1,
            },
            {
              title: 'sale_opt_seq',
              required: 'O',
              type: 'Number(5)',
              desc: '옵션순번',
              indent: 2,
            },
            {
              title: 'deal_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '옵션타입', allowedValues: ['일반', '추가구매'] }),
              indent: 2,
            },
            {
              title: 'opt_sort1',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 1',
              indent: 2,
            },
            {
              title: 'opt_sort2',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 2',
              indent: 2,
            },
            {
              title: 'opt_sort3',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 3',
              indent: 2,
            },
            {
              title: 'opt_sort4',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 4',
              indent: 2,
            },
            {
              title: 'opt_sort5',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 5',
              indent: 2,
            },
            {
              title: 'opt_name1',
              required: 'O',
              type: 'String(80)',
              desc: '옵션값 1',
              indent: 2,
            },
            {
              title: 'opt_name2',
              required: 'O',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값2', defaultValue: 'null' }),
              indent: 2,
            },
            {
              title: 'opt_name3',
              required: 'O',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값3', defaultValue: 'null' }),
              indent: 2,
            },
            {
              title: 'opt_name4',
              required: 'O',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값4', defaultValue: 'null' }),
              indent: 2,
            },
            {
              title: 'opt_name5',
              required: 'O',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값5', defaultValue: 'null' }),
              indent: 2,
            },
            {
              title: 'opt_status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '옵션상태', allowedValues: ['정상', '품절'] }),
              indent: 2,
            },
            {
              title: 'add_item_name',
              required: 'O',
              type: 'String(80)',
              desc: '추가구매옵션명',
              indent: 2,
            },
            {
              title: 'add_item_opt_name',
              required: 'O',
              type: 'String(80)',
              desc: '추가구매옵션값',
              indent: 2,
            },
            {
              title: 'opt_add_price',
              required: 'O',
              type: 'Number(9)',
              desc: apiParamDesc({ title: '옵션가격', defaultValue: '0' }),
              indent: 2,
            },
            {
              title: 'prod_no',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 sku 상품 고유번호',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 2,
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String(40)',
              desc: apiParamDesc({ title: '옵션에 매칭된 SKU상품 sku코드', sub: '(재고관리 미사용시 미노출)' }),
              indent: 2,
            },
            {
              title: 'prod_name',
              required: 'O',
              type: 'String(200)',
              desc: apiParamDesc({ title: '옵션에 매칭된 SKU상품명', sub: '(재고관리 미사용시 미노출)' }),
              indent: 2,
            },
            {
              title: 'stock_cd',
              required: 'O',
              type: 'String(100)',
              desc: apiParamDesc({ title: '옵션에 매칭된 SKU상품 재고관리코드', sub: '(재고관리 미사용시 미노출)' }),
              indent: 2,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number(9)',
              desc: '옵션수량',
              indent: 2,
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(100)',
              desc: '모델 번호',
              indent: 2,
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(100)',
              desc: apiParamDesc({ title: '옵션 바코드' }),
              indent: 2,
            },
            {
              title: 'pack_unit',
              required: 'O',
              type: 'Number(6)',
              desc: apiParamDesc({ title: '옵션에 매칭된 SKU상품 출고수량', sub: '(재고관리 미사용시 미노출)' }),
              indent: 2,
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number(8)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품 배송처',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 2,
            },
            {
              title: 'set_cd',
              required: 'O',
              type: 'String(40)',
              desc: apiParamDesc({ title: '옵션에 매칭된 세트상품코드', sub: '(재고관리 미사용시 미노출)' }),
              indent: 2,
            },
            {
              title: 'set_name',
              required: 'O',
              type: 'String(200)',
              desc: apiParamDesc({ title: '옵션에 매칭된 세트상품명', sub: '(재고관리 미사용시 미노출)' }),
              indent: 2,
            },
            {
              title: 'set_sale_price',
              required: 'O',
              type: 'String(9)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 세트상품 가격',
                sub: ' (재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 2,
            },
            {
              title: 'unit_price_yn',
              required: 'O',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 여부',
                allowedValues: ['true', 'false'],
                notes: ['std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 2,
            },
            {
              title: 'unit_capacity',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 용량',
                notes: [
                  '1 – 999 사이의 정수만 입력 가능합니다.',
                  'options.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
              indent: 2,
            },
            {
              title: 'indication_unit',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 단위',
                allowedValues: [
                  'g',
                  'kg',
                  'ml',
                  'L',
                  'cm',
                  'm',
                  '개',
                  '개입',
                  '매',
                  '매입',
                  '정',
                  '캡슐',
                  '구미',
                  '포',
                  '구',
                ],
                notes: ['options.unit_price_yn이 true일 때 필수 입력 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 2,
            },
            {
              title: 'unit_price_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 구성 방식',
                allowedValues: ['낱개', '팩'],
                notes: ['options.unit_price_yn이 true일 때 필수 입력 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 2,
            },
            {
              title: 'unit_price_pack_qty',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩 수량',
                notes: [
                  'options.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_pack_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 2,
            },
            {
              title: 'unit_price_item_qty',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩당 수량',
                notes: [
                  'options.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_item_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 2,
            },
            {
              title: 'unit_price_item_qty_unit',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩당 수량 단위',
                allowedValues: ['개', '개입', '매입', '매', '병', '캔', '통', '스틱', '알', '정', '캡슐', '구미', '장', '팩', '포'],
                notes: ['지그재그 채널 전송 시에만 사용되는 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 2,
            },
            {
              title: 'item_capacity',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 개당 용량',
                notes: [
                  'options.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '0.001 – 999999999.000 사이의 숫자만 입력 가능합니다. (소수점 셋째자리까지 지원)',
                ],
              }),
              indent: 2,
            },
            {
              title: 'prod_noti_data',
              required: 'O',
              type: 'Object',
              desc: apiParamDesc({ title: '상품정보제공고시', sub: '상품분류코드에 따라 infoDetail 안에 키 값이 달라질 수 있습니다.' }),
              indent: 1,
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: '상품분류코드',
              indent: 2,
            },
            {
              title: 'infoName',
              required: 'O',
              type: 'String',
              desc: '상품분류명',
              indent: 2,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'String',
              desc: '상품정보제공고시 데이터',
              indent: 2,
            },
            {
              title: 'ol_count',
              required: 'O',
              type: 'Number',
              desc: '검색된 마스터상품 수',
            },
            {
              title: 'normal_count',
              required: 'O',
              type: 'Number',
              desc: '검색된 일반상품 수',
            },
            {
              title: 'single_count',
              required: 'O',
              type: 'Number',
              desc: '검색된 단일상품 수',
            },
          ],
          response_example: {
            results: {
              m2022060881c9e7f86: [
                {
                  sol_no: 640,
                  ol_shop_no: 69224644,
                  c_sale_cd: 'm2022060881c9e7f86',
                  sol_cate_no: 301516,
                  shop_cd: 'Z000',
                  shop_name: '마스터 온라인상품',
                  shop_id: '',
                  template_no: 0,
                  shop_sale_name_addcontent_no: null,
                  addcontent_no: null,
                  shop_sale_name: '테스트 온라인 상품',
                  sale_status: '',
                  sale_cnt_limit: 99,
                  sale_price: 10000,
                  cost_price: 0,
                  supply_price: 0,
                  street_price: 0,
                  opt_type: '조합형',
                  input_opt_names: '',
                  tax_type: '과세',
                  ship_price_type: '무료',
                  ship_price: 0,
                  shop_sale_no: null,
                  sale_img1:
                    'https://s3-ap-northeast-2.amazonaws.com/gmp01/640/online/26070990/Z000/202111041549441.jpg',
                  sale_img2: '',
                  sale_img3: '',
                  sale_img4: '',
                  sale_img5: '',
                  sale_img6: '',
                  sale_img7: '',
                  sale_img8: '',
                  sale_img9: '',
                  sale_img10: '',
                  sale_img11: '',
                  detail_desc: '상세설명',
                  keywords: '',
                  model: '',
                  model_no: '',
                  brand: '',
                  maker: '',
                  wdate: '2022-06-08 19:31:16',
                  mdate: '2022-06-08 19:31:16',
                  std_ol_yn: 0,
                  unit_price_yn: true,
                  unit_capacity: 100,
                  indication_unit: 'ml',
                  unit_price_type: '낱개',
                  unit_price_pack_qty: 1,
                  unit_price_item_qty: 1,
                  unit_price_item_qty_unit: '개',
                  item_capacity: 500,
                  options: [
                    {
                      sale_opt_seq: 1,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_sort4: '',
                      opt_sort5: '',
                      opt_name1: '블랙',
                      opt_name2: 'L',
                      opt_name3: '',
                      opt_name4: '',
                      opt_name5: '',
                      opt_status: '정상',
                      add_item_name: '',
                      add_item_opt_name: '',
                      opt_add_price: 0,
                      prod_no: 16967900,
                      sku_cd: 'U005-BK-L',
                      prod_name: '21.비비드',
                      stock_cd: '05.기모반목',
                      stock_cnt: 77,
                      model_no: '',
                      barcode: '',
                      pack_unit: 1,
                      depot_no: 775,
                      set_cd: '',
                      set_name: '',
                      set_sale_price: 0,
                      unit_price_yn: true,
                      unit_capacity: 50,
                      indication_unit: 'g',
                      unit_price_type: '팩',
                      unit_price_pack_qty: 2,
                      unit_price_item_qty: 5,
                      unit_price_item_qty_unit: '개',
                      item_capacity: 10,
                    },
                    {
                      sale_opt_seq: 2,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_sort4: '',
                      opt_sort5: '',
                      opt_name1: '하늘',
                      opt_name2: 'L',
                      opt_name3: '',
                      opt_name4: '',
                      opt_name5: '',
                      opt_status: '정상',
                      add_item_name: '',
                      add_item_opt_name: '',
                      opt_add_price: 0,
                      prod_no: 16967891,
                      sku_cd: 'U004-S-L',
                      prod_name: '19.크레오라',
                      stock_cd: '04.기모라운드티셔츠',
                      stock_cnt: 66,
                      model_no: '',
                      barcode: '',
                      pack_unit: 1,
                      depot_no: 775,
                      set_cd: '',
                      set_name: '',
                      set_sale_price: 0,
                      unit_price_yn: false,
                    },
                  ],
                  prod_noti_data: {
                    infoCode: 'Wear2023',
                    infoName: '의류',
                    infoDetail: {
                      material: '1',
                      color: '2',
                      size: '3',
                      manufacturer: '4',
                      made_in: '5',
                      caution: '6',
                      release: '7',
                      warranty: '8',
                      customer_service: '9',
                    },
                  },
                },
                {
                  sol_no: 640,
                  ol_shop_no: 81325911,
                  c_sale_cd: 'm2022060881c9e7f86',
                  sol_cate_no: 301516,
                  shop_cd: 'A001',
                  shop_name: '옥션',
                  shop_id: 'myshopy3',
                  template_no: 273155,
                  shop_sale_name_addcontent_no: null,
                  addcontent_no: null,
                  shop_sale_name: '테스트 온라인상품',
                  sale_status: '판매중',
                  sale_cnt_limit: 99,
                  sale_price: 10000,
                  cost_price: 0,
                  supply_price: 0,
                  street_price: 0,
                  opt_type: '조합형',
                  input_opt_names: '',
                  tax_type: '과세',
                  ship_price_type: '무료',
                  ship_price: 0,
                  shop_sale_no: 'C1335724',
                  sale_img1:
                    'https://s3-ap-northeast-2.amazonaws.com/gmp01/640/online/26070990/A001myshopy3/202111041549441.jpg',
                  sale_img2: '',
                  sale_img3: '',
                  sale_img4: '',
                  sale_img5: '',
                  sale_img6: '',
                  sale_img7: '',
                  sale_img8: '',
                  sale_img9: '',
                  sale_img10: '',
                  sale_img11: '',
                  detail_desc: '상세설명',
                  keywords: '',
                  model: '',
                  model_no: '',
                  brand: '',
                  maker: '',
                  wdate: '2022-08-18 11:20:41',
                  mdate: '2022-08-18 15:44:32',
                  std_ol_yn: 0,
                  unit_price_yn: true,
                  unit_capacity: 100,
                  indication_unit: 'ml',
                  unit_price_type: '낱개',
                  unit_price_pack_qty: 1,
                  unit_price_item_qty: 1,
                  unit_price_item_qty_unit: '개',
                  item_capacity: 500,
                  options: [
                    {
                      sale_opt_seq: 1,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '',
                      opt_sort3: '',
                      opt_sort4: '',
                      opt_sort5: '',
                      opt_name1: '빨강',
                      opt_name2: '',
                      opt_name3: '',
                      opt_name4: '',
                      opt_name5: '',
                      opt_status: '정상',
                      add_item_name: '',
                      add_item_opt_name: '',
                      opt_add_price: 0,
                      prod_no: 0,
                      sku_cd: '',
                      prod_name: '',
                      stock_cd: '',
                      stock_cnt: 77,
                      model_no: '',
                      pack_unit: 0,
                      depot_no: 0,
                      set_cd: '',
                      set_name: '',
                      set_sale_price: 0,
                      unit_price_yn: true,
                      unit_capacity: 50,
                      indication_unit: 'g',
                      unit_price_type: '팩',
                      unit_price_pack_qty: 2,
                      unit_price_item_qty: 5,
                      unit_price_item_qty_unit: '개',
                      item_capacity: 10,
                    },
                    {
                      sale_opt_seq: 2,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '',
                      opt_sort3: '',
                      opt_sort4: '',
                      opt_sort5: '',
                      opt_name1: '파랑',
                      opt_name2: '',
                      opt_name3: '',
                      opt_name4: '',
                      opt_name5: '',
                      opt_status: '정상',
                      add_item_name: '',
                      add_item_opt_name: '',
                      opt_add_price: 0,
                      prod_no: 0,
                      sku_cd: '',
                      prod_name: '',
                      stock_cd: '',
                      stock_cnt: 88,
                      model_no: '',
                      pack_unit: 0,
                      depot_no: 0,
                      set_cd: '',
                      set_name: '',
                      set_sale_price: 0,
                      unit_price_yn: true,
                      unit_capacity: 50,
                      indication_unit: 'g',
                      unit_price_type: '팩',
                      unit_price_pack_qty: 2,
                      unit_price_item_qty: 5,
                      unit_price_item_qty_unit: '개',
                      item_capacity: 10,
                    }
                  ],
                  prod_noti_data: {
                    infoCode: 'Wear2023',
                    infoName: '의류',
                    infoDetail: {
                      material: '1',
                      color: '2',
                      size: '3',
                      manufacturer: '4',
                      made_in: '5',
                      caution: '6',
                      release: '7',
                      warranty: '8',
                      customer_service: '9',
                    },
                  },
                },
              ],
            },
            ol_count: 1,
            normal_count: 1,
            single_count: 0,
          },
        },
      ],
    },
    {
      title: '온라인상품 등록',
      url: '/doc/온라인상품 등록',
      data: [
        {
          version: 'v1.2',
          url: '/products/add/v1.2',
          desc: (
            <div>
              <ul className='style'>
                <li>온라인상품 정보를 등록합니다.</li>
                <li>
                  단일상품의 경우 쇼핑몰별로 입력가능한 옵션이 다를 수 있습니다.
                </li>
                <li>
                  해당경우 입력가능한 옵션정보가 같은 상품정보끼리 묶어
                  등록해주시기 바랍니다.
                </li>
              </ul>
              <pre className='prettyprint'>
                ex1 &gt; 조합형 옵션이고 옵션명이 색상, 옵션값이 빨강,
                파랑인경우 <br /> 색상-빨강, 색상-파랑
                <br /> 이런 형식으로 두개의 옵션정보가 생성되므로
                <br /> {'{'}
                <br /> opt_sort1: 색상,
                <br /> opt_sort1_desc: 빨강,
                <br /> ...
                <br /> {'}'},<br /> {'{'}
                <br /> opt_sort1: 색상,
                <br /> opt_sort1_desc: 파랑,
                <br /> ...
                <br /> {'}'}
                <br /> 의 형식으로 입력하면 됩니다.
                <br /> <br /> ex2 &gt; 조합형 옵션이고 옵션정보가 [색상 =
                빨강,파랑, 사이즈 = Large, Small] 인경우
                <br /> 빨강-Large, 파랑-Large, 빨강-Small, 파랑-Small
                <br /> 이런 형식으로 총 4개의 옵션정보가 생성되어야 합니다.
                <br /> {'{'}
                <br /> opt_sort1: 색상,
                <br /> opt_sort2: 사이즈,
                <br /> opt_sort1_desc: 빨강,
                <br /> opt_sort2_desc: Large,
                <br /> ...
                <br /> {'}'},<br /> {'{'}
                <br /> opt_sort1: 색상,
                <br /> opt_sort2: 사이즈,
                <br /> opt_sort1_desc: 빨강,
                <br /> opt_sort2_desc: Small
                <br /> ...
                <br /> {'}'},<br /> {'{'}
                <br /> opt_sort1: 색상,
                <br /> opt_sort2: 사이즈,
                <br /> opt_sort1_desc: 파랑,
                <br /> opt_sort2_desc: Large
                <br /> ...
                <br /> {'}'},<br /> {'{'}
                <br /> opt_sort1: 색상,
                <br /> opt_sort2: 사이즈,
                <br /> opt_sort1_desc: 파랑,
                <br /> opt_sort2_desc: Small
                <br /> ...
                <br /> {'}'}
                <br /> <br /> ex3&gt; 독립형 옵션인경우
                <br /> 독립형옵션인경우에는 opt_sort1 에 옵션명, opt_sort1_desc
                에 옵션값만 넣어주면 됩니다.
                <br /> 옵션명: 색상, 사이즈 <br /> 옵션값: Large, Small <br />{' '}
                위의 정보를 독립형 옵션으로 생성하는 경우
                <br /> {'{'}
                <br /> opt_sort1: 색상,
                <br /> opt_sort1_desc: 빨강,
                <br /> ...
                <br /> {'}'},<br /> {'{'}
                <br /> opt_sort1: 색상,
                <br /> opt_sort1_desc: 파랑,
                <br /> ...
                <br /> {'}'},<br /> {'{'}
                <br /> opt_sort1: 사이즈,
                <br /> opt_sort1_desc: Large,
                <br /> ...
                <br /> {'}'},<br /> {'{'}
                <br /> opt_sort1: 사이즈,
                <br /> opt_sort1_desc: Large,
                <br /> ...
                <br /> {'}'}
                <br /> 위의 방식으로 입력해주시면 됩니다.
                <br /> 이 방식은 추가구매 옵션등록시에도 동일합니다.{' '}
              </pre>
            </div>
          ),
          method: 'POST',
          unrecognized_aff_no: [1057],
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '판매자관리코드',
                notes: ['<strong><code>__AUTO__</code></strong>로 입력시 판매자관리코드를 자동생성합니다.'],
              }),
            },
            {
              title: 'sol_cate_no',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({ title: '카테고리코드', notes: ['카테고리 조회 api를 통해 확인된 카테고리 번호를 입력해주십시오.'] }),
            },
            {
              title: 'shop_sale_name',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품명',
                notes: [
                  '상품명은 최대 100Byte까지 등록가능합니다.',
                  '<strong><code>|</code></strong>, <strong><code>#</code></strong> 및 지원하지 않는 이모티콘은 사용할 수 없습니다.',
                ],
              }),
            },
            {
              title: 'adult_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '미성년자 구매여부', defaultValue: 'true' }),
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({ title: '판매가격', notes: ['금액은 10원 단위로 입력해주십시오.'] }),
            },
            {
              title: 'sale_cnt_limit',
              required: 'O',
              type: 'Number',
              desc: '판매수량',
            },
            {
              title: 'site_list',
              required: 'O',
              type: 'Object[]',
              desc: '등록할 쇼핑몰 정보',
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '쇼핑몰 코드',
                notes: ['쇼핑몰 코드조회 문서를 참고하여 등록하시려는 사이트의 코드를 입력해주십시오.'],
              }),
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 아이디',
              indent: 1,
            },
            {
              title: 'template_no',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({ title: '템플릿번호', notes: ['템플릿 조회 api를 통해 확인된 템플릿 번호를 입력해주십시오.'] }),
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '상품명 개별입력',
                notes: [
                  '상품명 글자 제한수는 쇼핑몰별로 상이합니다.',
                  '<strong><code>|</code></strong>, <strong><code>#</code></strong> 및 지원하지 않는 이모티콘은 사용할 수 없습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'shop_sale_name_addcontent_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품명 머리말/꼬리말 템플릿 번호',
                notes: ['머리말/꼬리말 조회 api를 통해 확인된 상품명 머리말/꼬리말 템플릿 번호를 입력해주십시오.'],
              }),
              indent: 1,
            },
            {
              title: 'addcontent_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상세설명 머리말/꼬리말 템플릿 번호',
                notes: ['머리말/꼬리말 조회 api를 통해 확인된 상세설명 머리말/꼬리말 템플릿 번호를 입력해주십시오.'],
              }),
              indent: 1,
            },
            {
              title: 'std_ol_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '단일상품여부', allowedValues: ['Y', 'N'] }),
            },
            {
              title: 'main_sku_cd',
              required: '',
              type: 'String',
              desc: '대표SKU상품 코드'
            },
            {
              title: 'opt_type',
              required: 'O',
              type: 'String',
              // [쇼핑몰 그룹 라벨 + 목록] 짝이 둘이라 notes 슬롯 하나로는 그룹을 구분할 수 없다.
              // sub 는 배열이고 원소마다 별도 블록으로 렌더되므로 그룹 하나를 원소 하나에 담는다
              desc: apiParamDesc({
                title: '옵션구분',
                sub: [
                  '<br/><h6>홈플러스, 갤러리아몰, 롯데ON</h6><ul style="color: gray"><li>마스터 상품에 옵션 일괄 설정 시 대표 SKU상품만 매칭된 \'옵션없음\' 상품으로 등록됩니다.</li><li>카테고리에 따라 옵션 설정이 필요한 상품은 온라인 상품 생성 후 상세에서 별도로 옵션을 생성해 주셔야 합니다.</li></ul>',
                  '<br/><h6>쿠팡</h6><ul style="color: gray"><li>쿠팡은 독립형 옵션 미지원으로 마스터 상품의 옵션을 독립형으로 설정하신 경우 대표 SKU상품만 매칭된 \'옵션없음\' 상품으로 등록됩니다.</li></ul>',
                ],
                allowedValues: ['옵션없음', '조합형', '독립형'],
              }),
            },
            {
              title: 'unit_price_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 여부',
                allowedValues: ['true', 'false'],
                notes: ['std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
            },
            {
              title: 'unit_capacity',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 용량',
                notes: [
                  '1 – 999 사이의 정수만 입력 가능합니다.',
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
            },
            {
              title: 'indication_unit',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 단위',
                allowedValues: [
                  'g',
                  'kg',
                  'ml',
                  'L',
                  'cm',
                  'm',
                  '개',
                  '개입',
                  '매',
                  '매입',
                  '정',
                  '캡슐',
                  '구미',
                  '포',
                  '구',
                ],
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
            },
            {
              title: 'unit_price_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 구성 방식',
                allowedValues: ['낱개', '팩'],
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
            },
            {
              title: 'unit_price_pack_qty',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩 수량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_pack_qty는 1로 설정됩니다.',
                ],
              }),
            },
            {
              title: 'unit_price_item_qty',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩당 수량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_item_qty는 1로 설정됩니다.',
                ],
              }),
            },
            {
              title: 'unit_price_item_qty_unit',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩당 수량 단위',
                allowedValues: ['개', '개입', '매입', '매', '병', '캔', '통', '스틱', '알', '정', '캡슐', '구미', '장', '팩', '포'],
                notes: ['지그재그 채널 전송 시에만 사용되는 항목입니다.', 'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
            },
            {
              title: 'item_capacity',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 개당 용량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '0.001 – 999999999.000 사이의 숫자만 입력 가능합니다. (소수점 셋째자리까지 지원)',
                ],
              }),
            },
            {
              title: 'opts',
              required: '',
              type: 'Object[]',
              desc: apiParamDesc({ title: '옵션', sub: '(옵션구분이 옵션없음이 아닌경우 필수입력.)' }),
            },
            {
              title: 'opt_sort1',
              required: 'O',
              type: 'String',
              desc: '옵션명1',
              indent: 1,
            },
            {
              title: 'opt_sort2',
              required: '',
              type: 'String',
              desc: '옵션명2',
              indent: 1,
            },
            {
              title: 'opt_sort3',
              required: '',
              type: 'String',
              desc: '옵션명3',
              indent: 1,
            },
            {
              title: 'opt_sort4',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션명4',
                notes: [
                  '옵션 4·5단은 옵션 5개 지원 쇼핑몰에서만 사용할 수 있습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'opt_sort5',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션명5',
                notes: [
                  '옵션 4·5단은 옵션 5개 지원 쇼핑몰에서만 사용할 수 있습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'opt_sort1_desc',
              required: 'O',
              type: 'String',
              desc: '옵션값1',
              indent: 1,
            },
            {
              title: 'opt_sort2_desc',
              required: '',
              type: 'String',
              desc: '옵션값2',
              indent: 1,
            },
            {
              title: 'opt_sort3_desc',
              required: '',
              type: 'String',
              desc: '옵션값3',
              indent: 1,
            },
            {
              title: 'opt_sort4_desc',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션값4',
                notes: [
                  '옵션 4·5단은 옵션 5개 지원 쇼핑몰에서만 사용할 수 있습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'opt_sort5_desc',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션값5',
                notes: [
                  '옵션 4·5단은 옵션 5개 지원 쇼핑몰에서만 사용할 수 있습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'opt_custom_cd',
              required: '',
              type: 'String',
              desc: '옵션관리코드',
              indent: 1,
            },
            {
              title: 'model_no',
              required: '',
              type: 'String(100)',
              desc: apiParamDesc({ title: '옵션 모델번호' }),
              indent: 1,
            },
            {
              title: 'barcode',
              required: '',
              type: 'String(50)',
              desc: apiParamDesc({ title: '옵션 바코드' }),
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: '',
              type: 'String',
              desc: 'sku 코드',
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: '',
              type: 'Number',
              desc: '출고수량',
              indent: 1,
            },
            {
              title: 'add_price',
              required: '',
              type: 'Number',
              desc: '추가옵션금액',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'weight',
              required: '',
              type: 'Number',
              desc: '옵션무게',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '옵션상태', allowedValues: ['정상', '품절'] }),
              indent: 1,
            },
            {
              title: 'unit_price_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 여부',
                allowedValues: ['true', 'false'],
                notes: ['std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'unit_capacity',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 용량',
                notes: [
                  '1 – 999 사이의 정수만 입력 가능합니다.',
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'indication_unit',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 단위',
                allowedValues: [
                  'g',
                  'kg',
                  'ml',
                  'L',
                  'cm',
                  'm',
                  '개',
                  '개입',
                  '매',
                  '매입',
                  '정',
                  '캡슐',
                  '구미',
                  '포',
                  '구',
                ],
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 구성 방식',
                allowedValues: ['낱개', '팩'],
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_pack_qty',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩 수량',
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_pack_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_item_qty',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩당 수량',
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_item_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_item_qty_unit',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩당 수량 단위',
                allowedValues: ['개', '개입', '매입', '매', '병', '캔', '통', '스틱', '알', '정', '캡슐', '구미', '장', '팩', '포'],
                notes: ['지그재그 채널 전송 시에만 사용되는 항목입니다.', 'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'item_capacity',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 개당 용량',
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '0.001 – 999999999.000 사이의 숫자만 입력 가능합니다. (소수점 셋째자리까지 지원)',
                ],
              }),
              indent: 1,
            },
            {
              title: 'input_opt',
              required: '',
              type: 'Array',
              desc: '입력형옵션',
            },
            {
              title: 'add_opts',
              required: '',
              type: 'Object[]',
              desc: '추가구매옵션',
            },
            {
              title: 'opt_sort',
              required: 'O',
              type: 'String',
              desc: '추가항목명',
              indent: 1,
            },
            {
              title: 'opt_sort_desc',
              required: 'O',
              type: 'String',
              desc: '추가옵션명',
              indent: 1,
            },
            {
              title: 'opt_custom_cd',
              required: '',
              type: 'String',
              desc: '옵션관리코드',
              indent: 1,
            },
            {
              title: 'model_no',
              required: '',
              type: 'String(50)',
              desc: apiParamDesc({ title: '추가구매옵션 모델번호' }),
              indent: 1,
            },
            {
              title: 'barcode',
              required: '',
              type: 'String(50)',
              desc: apiParamDesc({ title: '추가구매옵션 바코드' }),
              indent: 1,
            },
            {
              title: 'price',
              required: 'O',
              type: 'Number',
              desc: '추가금액',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: '',
              type: 'String',
              desc: 'sku 코드',
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: '',
              type: 'Number',
              desc: '출고수량',
              indent: 1,
            },
            {
              title: 'weight',
              required: '',
              type: 'Number',
              desc: '추가구매옵션무게',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '추가구매옵션 상태', allowedValues: ['정상', '품절'] }),
              indent: 1,
            },
            {
              title: 'tax_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '과세여부', allowedValues: ['과세', '면세', '영세', '비과세'] }),
            },
            {
              title: 'madein',
              required: 'O',
              type: 'object',
              desc: '원산지',
            },
            {
              title: 'madein_no',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({ title: '원산지번호', sub: '(원산지 조회 api 호출하여 확인)' }),
              indent: 1,
            },
            {
              title: 'madein_etc',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '기타원산지',
                sub: '(등록하려는 원산지가 origins에서 조회되지않을 때<br />madein_no를 비우고 madein_etc에 값을 입력합니다.)',
              }),
              indent: 1,
            },
            {
              title: 'multi_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '복수원산지여부', defaultValue: 'false' }),
              indent: 1,
            },
            {
              title: 'made_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '제조일자', sub: '(YYYY-MM-DD의 형식으로 입력해주십시오.)' }),
            },
            {
              title: 'expire_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '유효일자', sub: '(YYYY-MM-DD의 형식으로 입력해주십시오.)' }),
            },
            {
              title: 'detail_desc',
              required: 'O',
              type: 'String',
              desc: '상품상세설명',
            },
            {
              title: 'brand',
              required: '',
              type: 'String',
              desc: '브랜드',
            },
            {
              title: 'model',
              required: '',
              type: 'String',
              desc: '모델명',
            },
            {
              title: 'maker',
              required: '',
              type: 'String',
              desc: '제조사',
            },
            {
              title: 'keywords',
              required: '',
              type: 'String[]',
              desc: apiParamDesc({
                title: '키워드',
                notes: ['키워드는 최대 40개 까지 등록가능하며, 쇼핑몰에 상품전송시 쇼핑몰에서 지원하는 입력 갯수만큼만 전송됩니다.'],
              }),
            },
            {
              title: 'sale_img1',
              required: 'O',
              type: 'String',
              desc: '기본이미지 URL',
            },
            {
              title: 'sale_img2',
              required: '',
              type: 'String',
              desc: '추가이미지 1 URL',
            },
            {
              title: 'sale_img3',
              required: '',
              type: 'String',
              desc: '추가이미지 2 URL',
            },
            {
              title: 'sale_img4',
              required: '',
              type: 'String',
              desc: '추가이미지 3 URL',
            },
            {
              title: 'sale_img5',
              required: '',
              type: 'String',
              desc: '추가이미지 4 URL',
            },
            {
              title: 'sale_img6',
              required: '',
              type: 'String',
              desc: '추가이미지 5 URL',
            },
            {
              title: 'sale_img7',
              required: '',
              type: 'String',
              desc: '추가이미지 6 URL',
            },
            {
              title: 'sale_img8',
              required: '',
              type: 'String',
              desc: '추가이미지 7 URL',
            },
            {
              title: 'sale_img9',
              required: '',
              type: 'String',
              desc: '추가이미지 8 URL',
            },
            {
              title: 'sale_img10',
              required: '',
              type: 'String',
              desc: '추가이미지 9 URL',
            },
            {
              title: 'sale_img11',
              required: '',
              type: 'String',
              desc: '추가이미지 10 URL',
            },
            {
              title: 'prod_info',
              required: 'O',
              type: 'Object[]',
              desc: apiParamDesc({
                title: '상품정보제공고시',
                notes: [
                  '품목정보고시정보는 3개까지 입력가능합니다.',
                  '아래의 등록가이드를 참고해주세요.',
                  '<a href="https://gmp-master.s3.ap-northeast-2.amazonaws.com/download/Sample_prodInfo_guide_OPENAPI.xlsx" style="color: blue">상품 품목정보고시 가이드 개정판</a>',
                ],
              }),
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품분류코드',
                notes: [
                  '대표 SKU상품 정보를 사용하고 싶으신 경우 \'대표SKU상품\'으로 입력합니다.',
                  '대표 SKU상품으로 입력시 아래의 정보는 입력할 필요가 없습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'object',
              desc: apiParamDesc({
                title: '상품 정보 제공고시 데이터',
                notes: ['품목 정보고시 가이드에 기재된 각 항목에 따른 key와 value를 입력합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'is_desc_referred',
              type: 'boolean',
              desc: apiParamDesc({
                title: '상품 정보 제공고시 데이터 일괄 [상세설명참조] 적용',
                notes: ['해당 값을 <code>true</code> 로 설정 시 입력한 값과 상관 없이 일괄 <code>[상세설명참조]</code>로 적용됩니다.'],
              }),
              indent: 1,
            },
            {
              title: 'ship_price_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '배송방법', allowedValues: ['무료', '선결제', '착불'] }),
            },
            {
              title: 'ship_price',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '배송비', notes: ['배송방법이 무료가 아닌경우 필수 입니다.'] }),
            },
            {
              title: 'gift_name',
              required: '',
              type: 'String',
              desc: '사은품',
            },
            {
              title: 'supply_price',
              required: '',
              type: 'Number',
              desc: '공급가',
            },
            {
              title: 'cost_price',
              required: '',
              type: 'Number',
              desc: '원가',
            },
            {
              title: 'street_price',
              required: '',
              type: 'Number',
              desc: '시중가',
            },
            {
              title: 'global_barcode_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: 'UPC/EAN 타입', allowedValues: ['UPC', 'EAN'] }),
            },
            {
              title: 'global_barcode',
              required: '',
              type: 'Number',
              desc: 'UPC/EAN 코드',
            },
            {
              title: 'isbn',
              required: '',
              type: 'Number',
              desc: 'ISBN 코드',
            },
            {
              title: 'barcode',
              required: '',
              type: 'String',
              desc: '바코드',
            },
            {
              title: 'hscd',
              required: '',
              type: 'String',
              desc: 'HS코드',
            },
            {
              title: 'prod_weight',
              required: '',
              type: 'Number',
              desc: '상품무게',
            },
            {
              title: 'cert_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '인증정보타입',
                defaultValue: '인증대상아님',
                allowedValues: ['인증유형등록', '인증대상아님', '상세설명내등록'],
              }),
            },
            {
              title: 'certs',
              required: '',
              type: 'Array',
              desc: apiParamDesc({
                title: '인증정보',
                notes: ['인증정보는 10개까지 등록 가능합니다.', '인증정보타입이 인증유형등록인 경우 필수로 입력해주셔야 합니다.'],
              }),
            },
            {
              title: 'cert_cd',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '인증유형',
                notes: [
                  'cert_01: 생활용품 안전인증',
                  'cert_02: 생활용품 안전확인',
                  'cert_03: 생활용품 어린이보호포장',
                  'cert_04: 생활용품 안전품질표시',
                  'cert_05: 생활용품 공급자적합성확인',
                  'cert_06: 전기용품 안전인증',
                  'cert_07: 전기용품 안전확인',
                  'cert_08: 전기용품 공급자적합성확인',
                  'cert_09: 방송통신용품 적합성인증확인',
                  'cert_10: 어린이제품 안전인증',
                  'cert_11: 어린이제품 안전확인',
                  'cert_12: 어린이제품 공급자적합성확인',
                  'cert_13: 위해우려제품 자가검사',
                  'cert_14: 방송통신기자재 잠정인증',
                  'cert_15: 방송통신기자재 적합등록',
                  'cert_16: 원산지증명',
                  'cert_17: 해외안전인증',
                  'cert_18: 수입신고필증',
                  'cert_19: 친환경인증-무농약농산물',
                  'cert_20: 친환경인증-유기축산물',
                  'cert_21: 친환경인증-유기농산물',
                  'cert_22: 친환경인증-저농약농산물',
                  'cert_23: 친환경인증-무항생제축산물',
                  'cert_24: HACCP(위해요소 중점관리우수식품)',
                  'cert_25: GMP(우수건강기능식품 제조기준)',
                  'cert_26: GAP(농산물우수관리인증)',
                  'cert_27: 농산물이력추적관리',
                  'cert_28: 수산물품질인증',
                  'cert_29: 수산특산물품질인증',
                  'cert_30: 수산전통식품품질인증',
                  'cert_31: 친환경수산물품질인증',
                  'cert_32: 친환경수산가공품품질인증',
                  'cert_33: 전통식품 품질인증',
                  'cert_34: 유기가공식품 인증',
                  'cert_35: 가공식품 산업표준 KS인증',
                  'cert_36: 건강기능식품 광고사전심의',
                  'cert_37: 의료기기 광고사전심의',
                  'cert_38: 축산물 등급판정 확인서',
                  'cert_39: 도축검사증명서',
                  'cert_40: 식품명인(Grand master) 인증',
                  'cert_41: 사회적기업 인증',
                  'cert_42: 6차산업 인증',
                  'cert_43: 동물복지 인증',
                  'cert_44: 마을기업 인증',
                  'cert_45: 건강기능식품인증',
                  'cert_46: 생활화학제품',
                ],
              }),
              indent: 1,
            },
            {
              title: 'cert_exc_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '면제유형',
                allowedValues: ['kc_01', 'kc_02', 'kc_03'],
                notes: ['kc_01: 안전기준준수대상', 'kc_02: 구매대행', 'kc_03: 병행수입'],
              }),
              indent: 1,
            },
            {
              title: 'cert_ministry',
              required: '',
              type: 'String',
              desc: '인증기관',
              indent: 1,
            },
            {
              title: 'cert_no',
              required: 'O',
              type: 'String',
              desc: '인증번호',
              indent: 1,
            },
            {
              title: 'cert_model',
              required: '',
              type: 'String',
              desc: '인증모델',
              indent: 1,
            },
            {
              title: 'cert_cname',
              required: '',
              type: 'String',
              desc: '인증상호',
              indent: 1,
            },
            {
              title: 'cert_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '인증일', notes: ['YYYY-MM-DD의 날짜형식으로 입력해주십시오.'] }),
              indent: 1,
            },
            {
              title: 'cert_expire_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '인증만료일', notes: ['YYYY-MM-DD의 날짜형식으로 입력해주십시오.'] }),
              indent: 1,
            },
            {
              title: 'add_desc_info',
              required: '',
              type: 'Object',
              desc: (
                <div>
                  등록 상품이 쇼핑몰 29CM인 경우만 상세 설명 이미지
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>객체의 키 값은 쇼핑몰 코드</li>
                    <li>
                      상세 설명 이미지가 하나 이상은 반드시 존재해야 됩니다.
                    </li>
                    <li>
                      [image_type]
                      <ul className='style' style={{ color: 'gray' }}>
                        <li>4: 기본 타입</li> <li>5: 영상 타입</li>
                        <li>6: 타이틀 구분 타입</li>
                        <li>7: 이미지 링크 타입</li>
                      </ul>
                    </li>
                  </ul>
                  <pre>
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>"image_info"</span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='pun'>[</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'    {'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>&nbsp;&nbsp;&nbsp;&nbsp;"title"</span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"타이틀"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"content"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"설명"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>4</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'}'},</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>&nbsp;&nbsp;&nbsp;&nbsp;"title"</span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"타이틀"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"content"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"설명"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"added_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"VIDEO_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"added_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>1</span>
                    <span className='pun'>,</span>
                    <span className='pln'> </span>
                    <span className='com'> # 1: 유튜브, 2: 비메오</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>5</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'}'},</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>&nbsp;&nbsp;&nbsp;&nbsp;"title"</span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"타이틀"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='pun'>[</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'        {'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"content"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"설명"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_URL"</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'        }'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>&nbsp;&nbsp;&nbsp;&nbsp;],</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"is_layout"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"F"</span>
                    <span className='pun'>,</span>
                    <span className='pln'> </span>
                    <span className='com'>
                      {' '}
                      # "F": 레이아웃 1단, "T": 레이아웃 2단{' '}
                    </span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>6</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'}'},</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"added_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_LINK_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>7</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pln'> </span>
                    <span className='pun'>{'    }'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'}'}</span>
                    <span className='pln'> </span>
                  </pre>
                </div>
              ),
            },
          ],
          body_example: {
            c_sale_cd: '__AUTO__',
            sol_cate_no: 11354,
            shop_sale_name: 'api 테스트 상품',
            adult_yn: true,
            sale_price: 50000,
            sale_cnt_limit: 88,
            site_list: [
              {
                shop_cd: 'A112',
                shop_id: 'playauto',
                template_no: 49724,
              },
            ],
            std_ol_yn: 'N',
            opt_type: '독립형',
            unit_price_yn: true,
            unit_capacity: 100,
            indication_unit: 'ml',
            unit_price_type: '낱개',
            unit_price_pack_qty: 1,
            unit_price_item_qty: 1,
            unit_price_item_qty_unit: '개',
            item_capacity: 500,
            opts: [
              {
                opt_sort1: '색상',
                opt_sort2: '',
                opt_sort3: '',
                opt_sort4: '',
                opt_sort5: '',
                opt_sort1_desc: '빨강',
                opt_sort2_desc: '',
                opt_sort3_desc: '',
                opt_sort4_desc: '',
                opt_sort5_desc: '',
                opt_custom_cd: 'OPT_RED_01',
                model_no: 'MDL-RED-01',
                barcode: 'BAR-RED-01',
                sku_cd: 'S999C90F24324',
                pack_unit: 1,
                add_price: 0,
                stock_cnt: 99,
                weight: 0.5,
                status: '정상',
                unit_price_yn: true,
                unit_capacity: 50,
                indication_unit: 'g',
                unit_price_type: '팩',
                unit_price_pack_qty: 2,
                unit_price_item_qty: 5,
                unit_price_item_qty_unit: '개',
                item_capacity: 10,
              },
              {
                opt_sort1: '색상',
                opt_sort2: '',
                opt_sort3: '',
                opt_sort4: '',
                opt_sort5: '',
                opt_sort1_desc: '파랑',
                opt_sort2_desc: '',
                opt_sort3_desc: '',
                opt_sort4_desc: '',
                opt_sort5_desc: '',
                opt_custom_cd: 'OPT_BLUE_01',
                model_no: 'MDL-BLUE-01',
                barcode: 'BAR-BLUE-01',
                sku_cd: 'S999C47FA857424',
                pack_unit: 1,
                add_price: 5000,
                stock_cnt: 88,
                weight: '1',
                status: '품절',
                unit_price_yn: false
              },
            ],
            input_opt: ['입력형옵션1', '입력형옵션2'],
            add_opts: [
              {
                opt_sort: '추가구매타입',
                opt_sort_desc: '추가구매1',
                opt_custom_cd: 'ADD_OPT_01',
                model_no: 'MDL-01',
                barcode: 'BAR-01',
                price: 1000,
                stock_cnt: 20,
                sku_cd: 'S893688C196587',
                pack_unit: 2,
                weight: 0,
                status: '정상',
              },
              {
                opt_sort: '추가구매타입',
                opt_sort_desc: '추가구매2',
                opt_custom_cd: 'ADD_OPT_02',
                model_no: 'MDL-02',
                barcode: 'BAR-02',
                price: 2000,
                stock_cnt: 30,
                sku_cd: 'S1880FB9324',
                pack_unit: 1,
                weight: 1,
                status: '품절',
              },
            ],
            tax_type: '과세',
            madein: {
              madein_no: 2,
              madein_etc: '',
              multi_yn: false,
            },
            made_date: '2020-01-01',
            expire_date: '2021-03-01',
            detail_desc: '상세설명',
            brand: '브랜드',
            model: '모델명',
            maker: '제조사',
            sale_img1: 'https://sample.com/productImage.jpg',
            prod_info: [
              {
                infoCode: 'Wear2023',
                infoDetail: {
                  material: '1',
                  color: '2',
                  size: '3',
                  manufacturer: '4',
                  made_in: '5',
                  caution: '6',
                  release: '7',
                  warranty: '8',
                  customer_service: '9',
                },
              },
              {
                infoCode: 'Shoes2023',
                infoDetail: {
                  material: '1',
                  color: '2',
                  size: '3',
                  manufacturer: '4',
                  made_in: '5',
                  caution: '6',
                  warranty: '7',
                  customer_service: '8',
                },
              },
            ],
            add_desc_info: {
              image_info: [
                {
                  title: '타이틀',
                  content: '설명',
                  image_url: 'IMG_URL',
                  image_type: 4,
                },
              ],
            },
          },
          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공/실패',
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String',
              desc: '등록된 상품의 판매자관리코드',
            },
            {
              title: 'site_list',
              required: 'O',
              type: 'Object[]',
              desc: '등록된 상품 쇼핑몰 정보',
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 이름',
              indent: 1
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 코드',
              indent: 1
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 아이디 (마스터 상품의 경우 빈값 출력)',
              indent: 1
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number',
              desc: '등록된 온라인상품 고유번호',
              indent: 1
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '등록이 실패된 경우 에러메시지',
            },
          ],
          response_example: {
            result: '성공',
            c_sale_cd: 'm20200925497324',
            site_list: [
              {
                shop_name: '마스터 상품',
                shop_cd: 'Z000',
                shop_id: '',
                ol_shop_no: 11111111,
              },
              {
                shop_name: '더현대',
                shop_cd: 'A133',
                shop_id: 'playauto',
                ol_shop_no: 22222222,
              },
              {
                shop_name: '옥션',
                shop_cd: 'A001',
                shop_id: 'playauto',
                ol_shop_no: 33333333,
              },
            ],
            message: '',
          },
        },
      ],
    },
    {
      title: '온라인상품 상세 조회',
      url: '/doc/온라인상품 상세 조회',
      data: [
        {
          version: 'v1.2',
          url: '/products/:ol_shop_no/v1.2',
          desc: '사용중인 솔루션에 등록된 온라인상품 정보를 조회합니다.',
          method: 'GET',
          unrecognized_aff_no: [1057],
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'String',
              desc: '온라인상품 고유번호',
            },
          ],
          response: [
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: '온라인상품 고유번호',
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String(40)',
              desc: '판매자관리코드',
            },
            {
              title: 'sale_no',
              required: 'O',
              type: 'Number(11)',
              desc: apiParamDesc({ title: '마스터상품 고유번호', notes: ['해당 번호가 같은 온라인상품은 동일 마스터상품에 묶여있습니다.'] }),
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: apiParamDesc({ title: '온라인상품 등록시간', sub: '(YYYY-MM-DD HH:mm:ss)' }),
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: apiParamDesc({ title: '온라인상품 수정시간', sub: '(YYYY-MM-DD HH:mm:ss)' }),
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String(4)',
              desc: '사이트 코드',
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String(50)',
              desc: '사이트명',
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String(40)',
              desc: '사이트 아이디',
            },
            {
              title: 'std_ol_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '단일상품여부', sub: '(0: 일반상품, 1: 단일상품)' }),
            },
            {
              title: 'ship_price_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '배송방법', allowedValues: ['무료', '조건부무료', '착불', '선결제'] }),
            },
            {
              title: 'ship_price_free_criteria',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({ title: '조건부 무료배송 조건', notes: ['30000원 이상 미료일 때 30000'] }),
            },
            {
              title: 'ship_price',
              required: 'O',
              type: 'Number(8)',
              desc: '배송비',
            },
            {
              title: 'sale_status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 판매 상태',
                allowedValues: ['판매대기', '승인대기', '반려', '판매중', '종료대기', '수정대기', '판매중지', '일시품절'],
              }),
            },
            {
              title: 'sale_cnt_limit',
              required: 'O',
              type: 'Number(10)',
              desc: '쇼핑몰 판매수량',
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number(12)',
              desc: '판매가',
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: '공급가',
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: '원가',
            },
            {
              title: 'street_price',
              required: 'O',
              type: 'Number(12)',
              desc: '시중가',
            },
            {
              title: 'shop_sale_name',
              required: 'O',
              type: 'String(200)',
              desc: '쇼핑몰 상품명',
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String(40)',
              desc: apiParamDesc({ title: '쇼핑몰 상품코드', defaultValue: 'null' }),
            },
            {
              title: 'detail_desc',
              required: 'O',
              type: 'String(16777215)',
              desc: '상품 상세설명',
            },
            {
              title: 'shop_sale_name_addcontent_no',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({ title: '상품명 머릿말, 꼬릿말 번호', defaultValue: 'null' }),
            },
            {
              title: 'addcontent_co',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({ title: '상세설명 머릿말, 꼬릿말 번호', defaultValue: 'null' }),
            },
            {
              title: 'template_no',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({ title: '템플릿 번호', defaultValue: 'null' }),
            },
            {
              title: 'template_name',
              required: 'O',
              type: 'String(80)',
              desc: apiParamDesc({ title: '템플릿 이름', defaultValue: 'null' }),
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(50)',
              desc: '바코드',
            },
            {
              title: 'isbn',
              required: 'O',
              type: 'Number(13)',
              desc: apiParamDesc({ title: 'isbn 번호', defaultValue: 'null' }),
            },
            {
              title: 'adult_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '미성년자 구매가능여부', sub: '(0: 미성년자 구매가능, 1: 미성년자 구매불가)' }),
            },
            {
              title: 'cert_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '인증정보타입', allowedValues: ['인증유형등록', '인증대상아님', '상세설명내등록'] }),
            },
            {
              title: 'model',
              required: 'O',
              type: 'String(50)',
              desc: '모델명',
            },
            {
              title: 'brand',
              required: 'O',
              type: 'String(50)',
              desc: '브랜드',
            },
            {
              title: 'maker',
              required: 'O',
              type: 'String(50)',
              desc: '제조사',
            },
            {
              title: 'made_date',
              required: 'O',
              type: 'String(10)',
              desc: apiParamDesc({ title: '제조일', sub: '(YYYY-MM-DD)', defaultValue: 'null' }),
            },
            {
              title: 'expire_date',
              required: 'O',
              type: 'String(10)',
              desc: apiParamDesc({ title: '유효일', sub: ' (YYYY-MM-DD)', defaultValue: 'null' }),
            },
            {
              title: 'tax_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '과세여부', allowedValues: ['과세', '면세', '영세', '비과세'] }),
            },
            {
              title: 'sol_cate_no',
              required: 'O',
              type: 'Number(10)',
              desc: '솔루션 카테고리 번호',
            },
            {
              title: 'sol_cate_name',
              required: 'O',
              type: 'String(60)',
              desc: '솔루션 카테고리 이름',
            },
            {
              title: 'sale_img1',
              required: 'O',
              type: 'String(230)',
              desc: '기본이미지',
            },
            {
              title: 'sale_img2',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 1',
            },
            {
              title: 'sale_img3',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 2',
            },
            {
              title: 'sale_img4',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 3',
            },
            {
              title: 'sale_img5',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 4',
            },
            {
              title: 'sale_img6',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 5',
            },
            {
              title: 'sale_img7',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 6',
            },
            {
              title: 'sale_img8',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 7',
            },
            {
              title: 'sale_img9',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 8',
            },
            {
              title: 'sale_img10',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 9',
            },
            {
              title: 'sale_img11',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 10',
            },
            {
              title: 'sale_img12',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 11',
            },
            {
              title: 'sale_img13',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 12',
            },
            {
              title: 'sale_img14',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 13',
            },
            {
              title: 'sale_img15',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 14',
            },
            {
              title: 'madein_no',
              required: 'O',
              type: 'Number',
              desc: '원산지번호',
            },
            {
              title: 'madein_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '원산지 국내/해외 여부',
                defaultValue: 'null',
                allowedValues: ['국내', '해외', '원양선', '기타'],
              }),
            },
            {
              title: 'madein_group',
              required: 'O',
              type: 'String(30)',
              desc: apiParamDesc({ title: '원산지 시/도', defaultValue: 'null' }),
            },
            {
              title: 'madein_name',
              required: 'O',
              type: 'String(30)',
              desc: apiParamDesc({ title: '원산지 읍/면', defaultValue: 'null' }),
            },
            {
              title: 'madein_etc',
              required: 'O',
              type: 'String(30)',
              desc: apiParamDesc({ title: '기타원산지', defaultValue: 'null' }),
            },
            {
              title: 'multi_madein_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '복수원산지여부', sub: '(0: 복수원산지X, 1: 복수원산지O)' }),
            },
            {
              title: 'opt_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: 'dhqtusrnqns', allowedValues: ['옵션없음', '조합형', '독립형'] }),
            },
            {
              title: 'opt_sort1',
              required: 'O',
              type: 'String(20)',
              desc: '옵션명1(ex>색상)',
            },
            {
              title: 'opt_sort2',
              required: 'O',
              type: 'String(20)',
              desc: '옵션명2',
            },
            {
              title: 'opt_sort3',
              required: 'O',
              type: 'String(20)',
              desc: '옵션명3',
            },
            {
              title: 'opt_sort4',
              required: 'O',
              type: 'String(20)',
              desc: '옵션명4',
            },
            {
              title: 'opt_sort5',
              required: 'O',
              type: 'String(20)',
              desc: '옵션명5',
            },
            {
              title: 'opt_sort1_desc',
              required: 'O',
              type: 'String(65535)',
              desc: '옵션값1(ex>빨강)',
            },
            {
              title: 'opt_sort2_desc',
              required: 'O',
              type: 'String(65535)',
              desc: '옵션값2',
            },
            {
              title: 'opt_sort3_desc',
              required: 'O',
              type: 'String(65535)',
              desc: '옵션값3',
            },
            {
              title: 'opt_sort4_desc',
              required: 'O',
              type: 'String(65535)',
              desc: '옵션값4',
            },
            {
              title: 'opt_sort5_desc',
              required: 'O',
              type: 'String(65535)',
              desc: '옵션값5',
            },
            {
              title: 'input_opt',
              required: 'O',
              type: 'String[]',
              desc: '입력형옵션',
            },
            {
              title: 'keywords',
              required: 'O',
              type: 'String[]',
              desc: '키워드',
            },
            {
              title: 'prod_info',
              required: 'O',
              type: 'Object[]',
              desc: apiParamDesc({
                title: '상품정보제공고시',
                notes: ['상품분류코드에 따라 infoDetail 안에 키 값이 달라질 수 있습니다.'],
              }),
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: '상품분류코드',
              indent: 1,
            },
            {
              title: 'infoName',
              required: 'O',
              type: 'String',
              desc: '상품분류명',
              indent: 1,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'Object',
              desc: '상품정보제공고시 데이터',
              indent: 1,
            },
            {
              title: 'unit_price_yn',
              required: 'O',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 여부',
                allowedValues: ['true', 'false'],
                notes: ['std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
            },
            {
              title: 'unit_capacity',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 용량',
                notes: [
                  '1 – 999 사이의 정수만 입력 가능합니다.',
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
            },
            {
              title: 'indication_unit',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 단위',
                allowedValues: [
                  'g',
                  'kg',
                  'ml',
                  'L',
                  'cm',
                  'm',
                  '개',
                  '개입',
                  '매',
                  '매입',
                  '정',
                  '캡슐',
                  '구미',
                  '포',
                  '구',
                ],
                notes: ['unit_price_yn이 true일 때 필수 입력 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
            },
            {
              title: 'unit_price_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 구성 방식',
                allowedValues: ['낱개', '팩'],
                notes: ['unit_price_yn이 true일 때 필수 입력 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
            },
            {
              title: 'unit_price_pack_qty',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩 수량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_pack_qty는 1로 설정됩니다.',
                ],
              }),
            },
            {
              title: 'unit_price_item_qty',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩당 수량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_item_qty는 1로 설정됩니다.',
                ],
              }),
            },
            {
              title: 'unit_price_item_qty_unit',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩당 수량 단위',
                allowedValues: ['개', '개입', '매입', '매', '병', '캔', '통', '스틱', '알', '정', '캡슐', '구미', '장', '팩', '포'],
                notes: ['지그재그 채널 전송 시에만 사용되는 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
            },
            {
              title: 'item_capacity',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 개당 용량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '0.001 – 999999999.000 사이의 숫자만 입력 가능합니다. (소수점 셋째자리까지 지원)',
                ],
              }),
            },
            {
              title: 'opts',
              required: 'O',
              type: 'object[]',
              desc: apiParamDesc({ title: '옵션', notes: ['옵션없음이라도 SKU상품이 매칭되어있는 경우 하나의 데이터가 나옵니다.'] }),
            },
            {
              title: 'sale_opt_seq',
              required: 'O',
              type: 'Number(5)',
              desc: '옵션순번',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '옵션상태', allowedValues: ['정상', '품절'] }),
              indent: 1,
            },
            {
              title: 'opt_name1',
              required: 'O',
              type: 'String(80)',
              desc: '옵션값1',
              indent: 1,
            },
            {
              title: 'opt_name2',
              required: 'O',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값2', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'opt_name3',
              required: 'O',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값3', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'opt_name4',
              required: 'O',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값4', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'opt_name5',
              required: 'O',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값5', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'add_price',
              required: 'O',
              type: 'Number(9)',
              desc: '옵션가격',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number(8)',
              desc: '옵션수량',
              indent: 1,
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(100)',
              desc: '옵션 모델번호 (옵션값 우선, 옵션값이 없고 SKU매칭된 경우 SKU 모델번호가 조회됩니다)',
              indent: 1,
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(100)',
              desc: '옵션 바코드 (옵션값 우선, 옵션값이 없고 SKU매칭된 경우 SKU 바코드가 조회됩니다)',
              indent: 1,
            },
            {
              title: 'unit_price_yn',
              required: 'O',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 여부',
                allowedValues: ['true', 'false'],
                notes: ['std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'unit_capacity',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 용량',
                notes: [
                  '1 – 999 사이의 정수만 입력 가능합니다.',
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'indication_unit',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 단위',
                allowedValues: [
                  'g',
                  'kg',
                  'ml',
                  'L',
                  'cm',
                  'm',
                  '개',
                  '개입',
                  '매',
                  '매입',
                  '정',
                  '캡슐',
                  '구미',
                  '포',
                  '구',
                ],
                notes: ['opts.unit_price_yn이 true일 때 필수 입력 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 구성 방식',
                allowedValues: ['낱개', '팩'],
                notes: ['opts.unit_price_yn이 true일 때 필수 입력 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_pack_qty',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩 수량',
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_pack_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_item_qty',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩당 수량',
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_item_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_item_qty_unit',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩당 수량 단위',
                allowedValues: ['개', '개입', '매입', '매', '병', '캔', '통', '스틱', '알', '정', '캡슐', '구미', '장', '팩', '포'],
                notes: ['지그재그 채널 전송 시에만 사용되는 항목입니다.', 'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'item_capacity',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 개당 용량',
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 0(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '0.001 – 999999999.000 사이의 숫자만 입력 가능합니다. (소수점 셋째자리까지 지원)',
                ],
              }),
              indent: 1,
            },
            {
              title: 'set_no',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 세트상품 고유 번호',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
                notes: ['세트 상품 번호는 옵션 순번에 따라 출력됩니다.', '세트 상품 번호가 존재할 경우 sale_opt_seq로 옵션을 구분해주세요.'],
              }),
              indent: 1,
            },
            {
              title: 'prod_no',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품 고유 번호',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
                notes: [
                  '세트 상품을 매칭한 옵션의 경우 sku상품 관련 항목은 세트상품내 구성된 sku상품 별로 출력됩니다.',
                  '해당 항목이 다르더라도 sale_opt_seq가 같으면 동일한 옵션입니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number(8)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 배송처 번호',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: 'O',
              type: 'Number(6)',
              desc: apiParamDesc({ title: '출고수량', sub: '(재고관리 미사용시 미노출)' }),
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String(40)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품 sku 코드',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
                notes: [
                  '세트 상품을 매칭한 옵션의 경우 sku상품 관련 항목은 세트상품내 구성된 sku상품 별로 출력됩니다.',
                  '해당 항목이 다르더라도 sale_opt_seq가 같으면 동일 옵션입니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'prod_name',
              required: 'O',
              type: 'String(200)',
              desc: apiParamDesc({ title: '매칭된 SKU상품명', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'prod_img',
              required: 'O',
              type: 'String(255)',
              desc: apiParamDesc({ title: '옵션이미지', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'global_barcode_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: 'UPC/EAN',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
                allowedValues: ['UPC', 'EAN', 'KAN', 'JAN', 'HS코드'],
              }),
              indent: 1,
            },
            {
              title: 'global_barcode',
              required: 'O',
              type: 'String(13)',
              desc: apiParamDesc({ title: 'UPC/EAN', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'prod_weight',
              required: 'O',
              type: 'Number(7)',
              desc: apiParamDesc({ title: '옵션무게', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'stock_cd',
              required: 'O',
              type: 'String(100)',
              desc: apiParamDesc({ title: '재고관리코드', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'stock_cnt_enable',
              required: 'O',
              type: 'Number(8)',
              desc: apiParamDesc({ title: '판매가능재고', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'stock_cnt_safe',
              required: 'O',
              type: 'Number(8)',
              desc: apiParamDesc({ title: '안전재고', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품의 판매가',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품의 원가',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품의 공급가',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'set_name',
              required: 'O',
              type: 'String(200)',
              desc: apiParamDesc({ title: '옵션에 매칭된 세트상품명', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'set_sale_price',
              required: 'O',
              type: 'String(12)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 세트상품 가격',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'add_opts',
              required: 'O',
              type: 'object[]',
              desc: '추가구매 옵션',
            },
            {
              title: 'sale_opt_seq',
              required: 'O',
              type: 'Number(5)',
              desc: '옵션순번',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '옵션상태', allowedValues: ['정상', '품절'] }),
              indent: 1,
            },
            {
              title: 'opt_sort',
              required: 'O',
              type: 'String(50)',
              desc: '추가항목명',
              indent: 1,
            },
            {
              title: 'opt_sort_desc',
              required: 'O',
              type: 'String(50)',
              desc: '추가옵션명',
              indent: 1,
            },
            {
              title: 'price',
              required: 'O',
              type: 'Number(9)',
              desc: '추가금액',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number(9)',
              desc: '옵션수량',
              indent: 1,
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(100)',
              desc: '추가구매옵션 모델번호 (옵션값 우선, 옵션값이 없고 SKU매칭된 경우 SKU 모델번호가 조회됩니다)',
              indent: 1,
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(100)',
              desc: '추가구매옵션 바코드 (옵션값 우선, 옵션값이 없고 SKU매칭된 경우 SKU 바코드가 조회됩니다)',
              indent: 1,
            },
            {
              title: 'prod_no',
              required: 'O',
              type: 'Numbr(10)',
              desc: apiParamDesc({
                title: '매칭된 SKU상품 고유번호',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
                notes: [
                  '세트 상품을 매칭한 옵션의 경우 sku상품 관련 항목은 세트상품내 구성된 sku상품 별로 출력됩니다.',
                  '해당 항목이 다르더라도 sale_opt_seq가 같으면 동일 옵션입니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number(8)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 배송처 번호',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: 'O',
              type: 'Number(6)',
              desc: apiParamDesc({ title: '출고수량', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String(40)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품 sku 코드',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
                notes: [
                  '세트 상품을 매칭한 옵션의 경우 sku상품 관련 항목은 세트상품내 구성된 sku상품 별로 출력됩니다.',
                  '해당 항목이 다르더라도 sale_opt_seq가 같으면 동일 옵션입니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'prod_name',
              required: 'O',
              type: 'String(200)',
              desc: apiParamDesc({ title: '매칭된 SKU상품명', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'prod_img',
              required: 'O',
              type: 'String(255)',
              desc: apiParamDesc({ title: '옵션이미지', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'global_barcode_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: 'UPC/EAN',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
                allowedValues: ['UPC', 'EAN', 'KAN', 'JAN', 'HS코드'],
              }),
              indent: 1,
            },
            {
              title: 'global_barcode',
              required: 'O',
              type: 'String(13)',
              desc: apiParamDesc({ title: 'UPC/EAN 코드', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'prod_weight',
              required: 'O',
              type: 'Number(7)',
              desc: apiParamDesc({
                title: '옵션무게',
                sub: '(재고관리 미사용시 미노출)<br />(data type: Decimal(7,2))',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'stock_cnt_enable',
              required: 'O',
              type: 'Number(8)',
              desc: apiParamDesc({ title: '판매가능재고', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'stock_cnt_safe',
              required: 'O',
              type: 'Number(8)',
              desc: apiParamDesc({ title: '안전재고', sub: '(재고관리 미사용시 미노출)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품의 판매가',
                sub: '(재고관리 미사용시 미노출)<br />(data type: Decimal(12,2))',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품의 원가',
                sub: '(재고관리 미사용시 미노출)<br />(data type: Decimal(12,2))',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({
                title: '옵션에 매칭된 SKU상품의 공급가',
                sub: '(재고관리 미사용시 미노출)<br />(data type: Decimal(12,2))',
                defaultValue: 'null',
              }),
              indent: 1,
            },
            {
              title: 'certs',
              required: 'O',
              type: 'object[]',
              desc: '인증정보',
            },
            {
              title: 'ol_shop_cert_seq',
              required: 'O',
              type: 'object[]',
              desc: '인증번호 순번',
              indent: 1,
            },
            {
              title: 'cert_cd',
              required: 'O',
              type: 'String(7)',
              desc: apiParamDesc({
                title: '인증유형',
                notes: [
                  'cert_01: 생활용품 안전인증',
                  'cert_02: 생활용품 안전확인',
                  'cert_03: 생활용품 어린이보호포장',
                  'cert_04: 생활용품 안전품질표시',
                  'cert_05: 생활용품 공급자적합성확인',
                  'cert_06: 전기용품 안전인증',
                  'cert_07: 전기용품 안전확인',
                  'cert_08: 전기용품 공급자적합성확인',
                  'cert_09: 방송통신용품 적합성인증확인',
                  'cert_10: 어린이제품 안전인증',
                  'cert_11: 어린이제품 안전확인',
                  'cert_12: 어린이제품 공급자적합성확인',
                  'cert_13: 위해우려제품 자가검사',
                  'cert_14: 방송통신기자재 잠정인증',
                  'cert_15: 방송통신기자재 적합등록',
                  'cert_16: 원산지증명',
                  'cert_17: 해외안전인증',
                  'cert_18: 수입신고필증',
                  'cert_19: 친환경인증-무농약농산물',
                  'cert_20: 친환경인증-유기축산물',
                  'cert_21: 친환경인증-유기농산물',
                  'cert_22: 친환경인증-저농약농산물',
                  'cert_23: 친환경인증-무항생제축산물',
                  'cert_24: HACCP(위해요소 중점관리우수식품)',
                  'cert_25: GMP(우수건강기능식품 제조기준)',
                  'cert_26: GAP(농산물우수관리인증)',
                  'cert_27: 농산물이력추적관리',
                  'cert_28: 수산물품질인증',
                  'cert_29: 수산특산물품질인증',
                  'cert_30: 수산전통식품품질인증',
                  'cert_31: 친환경수산물품질인증',
                  'cert_32: 친환경수산가공품품질인증',
                  'cert_33: 전통식품 품질인증',
                  'cert_34: 유기가공식품 인증',
                  'cert_35: 가공식품 산업표준 KS인증',
                  'cert_36: 건강기능식품 광고사전심의',
                  'cert_37: 의료기기 광고사전심의',
                  'cert_38: 축산물 등급판정 확인서',
                  'cert_39: 도축검사증명서',
                  'cert_40: 식품명인(Grand master) 인증',
                  'cert_41: 사회적기업 인증',
                  'cert_42: 6차산업 인증',
                  'cert_43: 동물복지 인증',
                  'cert_44: 마을기업 인증',
                  'cert_45: 건강기능식품인증',
                  'cert_46: 생활화학제품',
                ],
              }),
              indent: 1,
            },
            {
              title: 'cert_exc_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '면제유형',
                allowedValues: ['kc_01', 'kc_02', 'kc_03'],
                notes: ['kc_01: 안전기준준수대상', 'kc_02: 구매대행', 'kc_03: 병행수입'],
              }),
              indent: 1,
            },
            {
              title: 'cert_ministry',
              required: 'O',
              type: 'String',
              desc: '인증기관',
              indent: 1,
            },
            {
              title: 'cert_no',
              required: 'O',
              type: 'String',
              desc: '인증번호',
              indent: 1,
            },
            {
              title: 'cert_model',
              required: 'O',
              type: 'String',
              desc: '인증모델',
              indent: 1,
            },
            {
              title: 'cert_cname',
              required: 'O',
              type: 'String',
              desc: '인증상호',
              indent: 1,
            },
            {
              title: 'cert_date',
              required: 'O',
              type: 'String',
              desc: '인증일',
              indent: 1,
            },
            {
              title: 'cert_expire_date',
              required: 'O',
              type: 'String',
              desc: '인증만료일',
              indent: 1,
            },
          ],
          response_example: {
            ol_shop_no: 25501010,
            c_sale_cd: 'm202105314fade7e8a',
            sale_no: 11142002,
            wdate: '2021-05-31 11:28:16',
            mdate: '2021-06-03 17:26:20',
            sol_no: 640,
            shop_cd: 'A001',
            shop_name: '옥션',
            shop_id: 'myshopy3',
            std_ol_yn: 0,
            ship_price_type: '선결제',
            ship_price_free_criteria: 0,
            ship_price: 3000,
            sale_status: '판매대기',
            sale_cnt_limit: 6543,
            sale_price: 110000,
            supply_price: 100000,
            cost_price: 90000,
            street_price: 120000,
            shop_sale_name: '2.2.22.0 STG 추가구매옵션 테스트',
            shop_sale_no: null,
            detail_desc: 'TEST',
            shop_sale_name_addcontent_no: null,
            addcontent_no: 1561,
            template_no: 262177,
            template_name: '테스트1',
            barcode: '',
            isbn: 7777777777777,
            adult_yn: 0,
            cert_type: '인증유형등록',
            model: '모델명',
            brand: '브랜드',
            maker: '제조사',
            made_date: '2021-01-01',
            expire_date: '2022-01-01',
            tax_type: '면세',
            sol_cate_no: 226970,
            sol_cate_name: '테스트: 테스트',
            sale_img1:
              'https://s3-ap-northeast-2.amazonaws.com/202105281154121.jpg',
            sale_img2: '',
            sale_img3: '',
            sale_img4: '',
            sale_img5: '',
            sale_img6: '',
            sale_img7: '',
            sale_img8: '',
            sale_img9: '',
            sale_img10: '',
            sale_img11: '',
            sale_img12: '',
            sale_img13: '',
            sale_img14: '',
            sale_img15: '',
            madein_no: 20,
            madein_type: '국내',
            madein_group: '경기',
            madein_name: '고양시',
            madein_etc: null,
            multi_madein_yn: 0,
            set_info: {
              rdoMode: '',
              madein_type: '기타',
              key_rdoOriginProductType: '4',
            },
            opt_type: '조합형',
            opt_sort1: '색상',
            opt_sort2: '사이즈',
            opt_sort3: '',
            opt_sort4: '',
            opt_sort5: '',
            opt_sort1_desc: '빨강,파랑',
            opt_sort2_desc: 'S,L',
            opt_sort3_desc: '',
            opt_sort4_desc: '',
            opt_sort5_desc: '',
            input_opt: ['입력형옵션1', '입력형옵션2'],
            keywords: ['키워드1', '키워드2', '키워드3'],
            prod_info: [{
              infoCode: 'Wear2023',
              infoName: '의류',
              infoDetail: {
                material: '1',
                color: '2',
                size: '3',
                manufacturer: '4',
                made_in: '5',
                caution: '6',
                release: '7',
                warranty: '8',
                customer_service: '9',
              },
            }],
            unit_price_yn: true,
            unit_capacity: 100,
            indication_unit: 'ml',
            unit_price_type: '낱개',
            unit_price_pack_qty: 1,
            unit_price_item_qty: 1,
            unit_price_item_qty_unit: '개',
            item_capacity: 500,
            opts: [
              {
                sale_opt_seq: 1,
                status: '정상',
                opt_name1: '빨강',
                opt_name2: 'S',
                opt_name3: '',
                opt_name4: '',
                opt_name5: '',
                add_price: 0,
                stock_cnt: 10,
                prod_no: 4613545,
                depot_no: 775,
                pack_unit: 1,
                opt_custom_cd: 'OPT_RED_S_01',
                model_no: 'MDL-RED-S-01',
                barcode: 'BAR-RED-S-01',
                sku_cd: 'S999C90F18A4',
                prod_name: '캐주얼 FW다운/패딩 45종 특별할인전',
                prod_img:
                  'https://s3-ap-northeast-2.amazonaws.com/20191109021116.jpg',
                global_barcode: '8801234567893',
                global_barcode_type: 'EAN',
                prod_weight: null,
                stock_cd: null,
                stock_cnt_safe: 20,
                sale_price: 20000,
                cost_price: 0,
                supply_price: 0,
                set_name: null,
                set_sale_price: null,
                unit_price_yn: true,
                unit_capacity: 50,
                indication_unit: '개',
                unit_price_type: '팩',
                unit_price_pack_qty: 2,
                unit_price_item_qty: 5,
                unit_price_item_qty_unit: '개',
                item_capacity: 10,

              },
              {
                sale_opt_seq: 2,
                status: '정상',
                opt_name1: '빨강',
                opt_name2: 'L',
                opt_name3: '',
                opt_name4: '',
                opt_name5: '',
                add_price: 0,
                stock_cnt: 593,
                prod_no: 4635349,
                depot_no: 775,
                pack_unit: 2,
                opt_custom_cd: 'OPT_RED_L_01',
                model_no: 'MDL-RED-L-01',
                barcode: 'BAR-RED-L-01',
                sku_cd: 'S999C47FACA0',
                prod_name: '캐주얼 FW다운/패딩 45종 특별할인전',
                prod_img:
                  'https://s3-ap-northeast-2.amazonaws.com/20191113185544.jpg',
                global_barcode: '8801234567893',
                global_barcode_type: 'EAN',
                prod_weight: null,
                stock_cd: null,
                stock_cnt_safe: 0,
                sale_price: 20000,
                cost_price: 0,
                supply_price: 0,
                set_name: null,
                set_sale_price: null,
                unit_prcie_yn: false,
              },
              {
                sale_opt_seq: 3,
                status: '정상',
                opt_name1: '파랑',
                opt_name2: 'S',
                opt_name3: '',
                opt_name4: '',
                opt_name5: '',
                add_price: 0,
                stock_cnt: 509,
                prod_no: 4638276,
                depot_no: 775,
                pack_unit: 3,
                opt_custom_cd: 'OPT_BLUE_S_01',
                model_no: 'MDL-BLUE-S-01',
                barcode: 'BAR-BLUE-S-01',
                sku_cd: 'S999B255A306',
                prod_name: '캐주얼 FW다운/패딩 45종 특별할인전',
                prod_img:
                  'https://s3-ap-northeast-2.amazonaws.com/20191113190646.jpg',
                global_barcode: '8801234567893',
                global_barcode_type: 'EAN',
                prod_weight: null,
                stock_cd: null,
                stock_cnt_safe: 0,
                sale_price: 20000,
                cost_price: 0,
                supply_price: 0,
                set_name: null,
                set_sale_price: null,
                unit_prcie_yn: false,
              },
              {
                sale_opt_seq: 4,
                status: '정상',
                opt_name1: '파랑',
                opt_name2: 'L',
                opt_name3: '',
                opt_name4: '',
                opt_name5: '',
                add_price: 0,
                stock_cnt: 499,
                prod_no: 4632672,
                depot_no: 775,
                pack_unit: 4,
                opt_custom_cd: 'OPT_BLUE_L_01',
                model_no: 'MDL-BLUE-L-01',
                barcode: 'BAR-BLUE-L-01',
                sku_cd: 'S9997BBA2AC8',
                prod_name: '캐주얼 FW다운/패딩 45종 특별할인전',
                prod_img:
                  'https://s3-ap-northeast-2.amazonaws.com/20191113184913.jpg',
                global_barcode: '8801234567893',
                global_barcode_type: 'EAN',
                prod_weight: null,
                stock_cd: null,
                stock_cnt_safe: null,
                sale_price: 20000,
                cost_price: 0,
                supply_price: 0,
                set_name: null,
                set_sale_price: null,
                unit_prcie_yn: false,
              },
            ],
            add_opts: [
              {
                sale_opt_seq: 5,
                status: '정상',
                opt_sort: '추가구매옵션',
                opt_sort_desc: '추가옵션명1',
                opt_custom_cd: 'ADD_OPT_01',
                model_no: 'MDL-01',
                barcode: 'BAR-01',
                price: 0,
                stock_cnt: 499,
                prod_no: 4633241,
                depot_no: 775,
                pack_unit: 77,
                sku_cd: 'S9993B1E90E3',
                prod_name: '캐주얼 FW다운/패딩 45종 특별할인전',
                prod_img:
                  'https://s3-ap-northeast-2.amazonaws.com/20191113184946.jpg',
                global_barcode: '8801234567893',
                global_barcode_type: 'EAN',
                prod_weight: null,
                stock_cnt_safe: null,
                sale_price: 20000,
                cost_price: 0,
                supply_price: 0,
              },
              {
                sale_opt_seq: 6,
                status: '정상',
                opt_sort: '추가구매옵션',
                opt_sort_desc: '추가옵션명2',
                opt_custom_cd: 'ADD_OPT_02',
                model_no: 'MDL-02',
                barcode: 'BAR-02',
                price: 500,
                stock_cnt: 500,
                prod_no: 4613868,
                depot_no: 775,
                pack_unit: 77,
                sku_cd: 'S9991917BCED',
                prod_name: '캐주얼 FW다운/패딩 45종 특별할인전',
                prod_img:
                  'https://s3-ap-northeast-2.amazonaws.com/20191109021149.jpg',
                global_barcode: '8801234567893',
                global_barcode_type: 'EAN',
                prod_weight: null,
                stock_cnt_safe: null,
                sale_price: 20000,
                cost_price: 0,
                supply_price: 0,
              },
            ],
            certs: [
              {
                ol_shop_cert_seq: 1,
                cert_cd: 'cert_01',
                cert_exc_type: 'kc_01',
                cert_ministry: '인증기관',
                cert_no: '인증번호',
                cert_model: '인증모델',
                cert_cname: '인증상호',
                cert_date: '2021-03-01',
                cert_expire_date: '2021-12-31',
              },
            ],
          },
        },
      ],
    },
    {
      title: '온라인상품 수정',
      url: '/doc/온라인상품 수정',
      data: [
        {
          version: 'v1.2',
          url: '/products/edit/v1.2',
          desc: apiDocDesc({ items: ['온라인상품 정보를 수정합니다.'] }),
          method: 'PUT',
          unrecognized_aff_no: [1057],
          header: default_header,
          header_example: default_header_example,
          body: [
            ...(userInfo.sol_no === 104083 ? [{
              title: 'sub_sol_no',
              required: '',
              type: 'Number',
              desc: '하위 계정 sol_no',
            }] : []),
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String',
              desc: '판매자관리코드',
            },
            {
              title: 'sol_cate_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '카테고리코드', notes: ['카테고리 수정이 필요한 경우 입력해주십시오.'] }),
            },
            {
              title: 'shop_sale_name',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '상품명',
                notes: [
                  '상품명은 최대 100Byte까지 등록가능합니다.',
                  '<strong><code>|</code></strong>, <strong><code>#</code></strong> 및 지원하지 않는 이모티콘은 사용할 수 없습니다.',
                ],
              }),
            },
            ...(userInfo.sol_no === 104083 ? [{
              title: 'shop_promotion_name',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: 'OEM 부품번호',
                notes: [
                  'OEM 부품번호는 100byte까지 입력 가능합니다',
                  '영문, 숫자만 입력 가능하며, 1개 이상 입력 시 콤마(,)로 구분해 입력 가능합니다.',
                ],
              }),
            }]: []),
            ...(userInfo.sol_no === 104083 ? [{
              title: 'model_no',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '차대 번호',
                notes: ['차대 번호는 50byte까지 입력 가능합니다', '영문, 숫자만 입력 가능합니다.'],
              }),
            }]: []),
            {
              title: 'adult_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '미성년자 구매여부', defaultValue: 'true' }),
            },
            {
              title: 'sale_price',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '판매가격', notes: ['금액은 10원 단위로 입력해주십시오.'] }),
            },
            {
              title: 'sale_cnt_limit',
              required: '',
              type: 'Number',
              desc: '판매수량',
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '쇼핑몰 코드',
                notes: [
                  '쇼핑몰코드조회 문서를 참고하여 등록하시려는 사이트의 코드를 입력해주십시오.',
                  '마스터상품을 수정하기 원하시는경우 해당 코드를 \'master\'로 입력해주십시오.',
                ],
              }),
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '쇼핑몰 아이디',
                notes: ['마스터상품을 수정하기 원하시는 경우 해당값을 <code>master</code>로 입력해주십시오.'],
              }),
            },
            {
              title: 'edit_slave_all',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '쇼핑몰 상품 연동 수정 여부',
                notes: [
                  '마스터 상품 수정일 경우 하위 쇼핑몰 상품 수정 여부',
                  '연동된 쇼핑몰 상품 중 쿠팡, 갤러리아몰, 롯데ON 상품 및 단일상품(옥션, 지마켓 제외)은 옵션이 수정되지 않고 기존 옵션이 유지됩니다.',
                ],
              }),
            },
            {
              title: 'template_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '템플릿번호', notes: ['템플릿 조회 api를 통해 확인된 템플릿 번호를 입력해주십시오.'] }),
            },
            {
              title: 'shop_sale_name_addcontent_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품명 머리말/꼬리말 번호',
                notes: ['머리말/꼬리말 조회 api를 통해 확인된 번호를 입력해주십시오.'],
              }),
            },
            {
              title: 'addcontent_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상세설명 머리말/꼬리말 번호',
                notes: ['머리말/꼬리말 조회 api를 통해 확인된 번호를 입력해주십시오.'],
              }),
            },
            {
              title: 'std_ol_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '단일상품여부',
                allowedValues: ['Y', 'N'],
                notes: ['값 미입력시 일반상품으로 조회되니 단일상품을 수정할 경우 반드시 값을 입력해주십시오.'],
              }),
            },
            {
              title: 'main_sku_cd',
              required: '',
              type: 'String',
              desc: '대표SKU상품 코드'
            },
            {
              title: 'opt_type',
              required: '',
              type: 'String',
              // 위 opt_type 과 같은 그룹 형태다. 원문에 파라미터 설명 텍스트가 없어 title 을 비운다.
              // 첫 라벨을 제목으로 올리면 두 그룹 중 하나만 제목이 되어 대칭이 깨진다
              desc: apiParamDesc({
                title: '',
                sub: [
                  '<br/><h6>홈플러스, 갤러리아몰, 롯데ON</h6><ul style="color: gray"><li>옵션없음으로 수정이 불가능합니다.</li></ul>',
                  '<br/><h6>쿠팡</h6><ul style="color: gray"><li>쇼핑몰에서 옵션명 수정이 불가하므로 옵션수정을 지원하지 않습니다.</li></ul>',
                ],
                allowedValues: ['옵션없음', '조합형', '독립형'],
              }),
            },
            {
              title: 'unit_price_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 여부',
                allowedValues: ['true', 'false'],
                notes: ['std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
            },
            {
              title: 'unit_capacity',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 용량',
                notes: [
                  '1 – 999 사이의 정수만 입력 가능합니다.',
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
            },
            {
              title: 'indication_unit',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 표시 단위',
                allowedValues: [
                  'g',
                  'kg',
                  'ml',
                  'L',
                  'cm',
                  'm',
                  '개',
                  '개입',
                  '매',
                  '매입',
                  '정',
                  '캡슐',
                  '구미',
                  '포',
                  '구',
                ],
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
            },
            {
              title: 'unit_price_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 구성 방식',
                allowedValues: ['낱개', '팩'],
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
            },
            {
              title: 'unit_price_pack_qty',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩 수량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_pack_qty는 1로 설정됩니다.',
                ],
              }),
            },
            {
              title: 'unit_price_item_qty',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩당 수량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_item_qty는 1로 설정됩니다.',
                ],
              }),
            },
            {
              title: 'unit_price_item_qty_unit',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 단위 가격 팩당 수량 단위',
                allowedValues: ['개', '개입', '매입', '매', '병', '캔', '통', '스틱', '알', '정', '캡슐', '구미', '장', '팩', '포'],
                notes: ['지그재그 채널 전송 시에만 사용되는 항목입니다.', 'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
            },
            {
              title: 'item_capacity',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '상품 단위 가격 개당 용량',
                notes: [
                  'unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '0.001 – 999999999.000 사이의 숫자만 입력 가능합니다. (소수점 셋째자리까지 지원)',
                ],
              }),
            },
            {
              title: 'opts',
              required: '',
              type: 'Object[]',
              desc: apiParamDesc({ title: '옵션', sub: '(옵션구분이 옵션없음이 아닌경우 필수입력.)' }),
            },
            {
              title: 'opt_sort1',
              required: 'O',
              type: 'String',
              desc: '옵션명1',
              indent: 1,
            },
            {
              title: 'opt_sort2',
              required: '',
              type: 'String',
              desc: '옵션명2',
              indent: 1,
            },
            {
              title: 'opt_sort3',
              required: '',
              type: 'String',
              desc: '옵션명3',
              indent: 1,
            },
            {
              title: 'opt_sort4',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션명4',
                notes: [
                  '옵션 4·5단은 옵션 5개 지원 쇼핑몰에서만 사용할 수 있습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'opt_sort5',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션명5',
                notes: [
                  '옵션 4·5단은 옵션 5개 지원 쇼핑몰에서만 사용할 수 있습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'opt_sort1_desc',
              required: 'O',
              type: 'String',
              desc: '옵션값1',
              indent: 1,
            },
            {
              title: 'opt_sort2_desc',
              required: '',
              type: 'String',
              desc: '옵션값2',
              indent: 1,
            },
            {
              title: 'opt_sort3_desc',
              required: '',
              type: 'String',
              desc: '옵션값3',
              indent: 1,
            },
            {
              title: 'opt_sort4_desc',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션값4',
                notes: [
                  '옵션 4·5단은 옵션 5개 지원 쇼핑몰에서만 사용할 수 있습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'opt_sort5_desc',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션값5',
                notes: [
                  '옵션 4·5단은 옵션 5개 지원 쇼핑몰에서만 사용할 수 있습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'opt_custom_cd',
              required: '',
              type: 'String',
              desc: '옵션관리코드',
              indent: 1,
            },
            {
              title: 'model_no',
              required: '',
              type: 'String(100)',
              desc: apiParamDesc({ title: '옵션 모델번호' }),
              indent: 1,
            },
            {
              title: 'barcode',
              required: '',
              type: 'String(100)',
              desc: apiParamDesc({ title: '옵션 바코드' }),
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: 'sku코드',
                notes: [
                  'sku코드 매칭시 모든 옵션의 sku코드를 입력해야 합니다.',
                  'sku코드를 매칭하지 않는 옵션이 있을 경우 모든 옵션의 sku코드를 비워주십시오.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: '',
              type: 'Number',
              desc: '출고수량',
              indent: 1,
            },
            {
              title: 'add_price',
              required: '',
              type: 'Number',
              desc: '추가옵션금액',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Numbr',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'weight',
              required: '',
              type: 'Number',
              desc: '옵션무게',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '옵션상태', allowedValues: ['정상', '품절'] }),
              indent: 1,
            },
            {
              title: 'unit_price_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 여부',
                allowedValues: ['true', 'false'],
                notes: ['std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'unit_capacity',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 용량',
                notes: [
                  '1 – 999 사이의 정수만 입력 가능합니다.',
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'indication_unit',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 표시 단위',
                allowedValues: [
                  'g',
                  'kg',
                  'ml',
                  'L',
                  'cm',
                  'm',
                  '개',
                  '개입',
                  '매',
                  '매입',
                  '정',
                  '캡슐',
                  '구미',
                  '포',
                  '구',
                ],
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 구성 방식',
                allowedValues: ['낱개', '팩'],
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_pack_qty',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩 수량',
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_pack_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_item_qty',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩당 수량',
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '1 – 9999 사이의 정수만 입력 가능합니다.',
                  'unit_price_type이 \'낱개\'일 때 unit_price_item_qty는 1로 설정됩니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'unit_price_item_qty_unit',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 단위 가격 팩당 수량 단위',
                allowedValues: ['개', '개입', '매입', '매', '병', '캔', '통', '스틱', '알', '정', '캡슐', '구미', '장', '팩', '포'],
                notes: ['지그재그 채널 전송 시에만 사용되는 항목입니다.', 'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'item_capacity',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션 단위 가격 개당 용량',
                notes: [
                  'opts.unit_price_yn이 true일 때 필수 입력 항목입니다.',
                  'std_ol_yn이 \'N\'(일반상품)인 경우 첫번째 값만 사용합니다.',
                  '0.001 – 999999999.000 사이의 숫자만 입력 가능합니다. (소수점 셋째자리까지 지원)',
                ],
              }),
              indent: 1,
            },
            {
              title: 'input_opt',
              required: '',
              type: 'String[]',
              desc: '입력형옵션',
            },
            {
              title: 'add_opts',
              required: '',
              type: 'Object[]',
              desc: '추가구매옵션',
            },
            {
              title: 'opt_sort',
              required: 'O',
              type: 'String',
              desc: '추가항목명',
              indent: 1,
            },
            {
              title: 'opt_sort_desc',
              required: 'O',
              type: 'String',
              desc: '추가옵션명',
              indent: 1,
            },
            {
              title: 'opt_custom_cd',
              required: '',
              type: 'String',
              desc: '옵션관리코드',
              indent: 1,
            },
            {
              title: 'model_no',
              required: '',
              type: 'String(50)',
              desc: apiParamDesc({ title: '추가구매옵션 모델번호' }),
              indent: 1,
            },
            {
              title: 'barcode',
              required: '',
              type: 'String(50)',
              desc: apiParamDesc({ title: '추가구매옵션 바코드' }),
              indent: 1,
            },
            {
              title: 'price',
              required: 'O',
              type: 'Number',
              desc: '추가금액',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: '',
              type: 'String',
              desc: 'sku 코드',
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: '',
              type: 'Number',
              desc: '출고수량',
              indent: 1,
            },
            {
              title: 'weight',
              required: '',
              type: 'Number',
              desc: '추가구매옵션무게',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '추가구매옵션 상태', allowedValues: ['정상', '품절'] }),
              indent: 1,
            },
            {
              title: 'tax_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '과세여부', allowedValues: ['과세', '면세', '영세', '비과세'] }),
            },
            {
              title: 'madein',
              required: '',
              type: 'Object',
              desc: '원산지',
            },
            {
              title: 'madein_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '원산지번호', sub: '(원산지 조회 api 호출하여 확인)' }),
              indent: 1,
            },
            {
              title: 'madein_etc',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '기타원산지',
                sub: '(등록하려는 원산지가 origins에서 조회되지않을때 madein_no를 비우고 madein_etc에 값을 입력합니다.)',
              }),
              indent: 1,
            },
            {
              title: 'multi_yn',
              required: '',
              type: 'Boolean',
              desc: '복수원산지여부',
              indent: 1,
            },
            {
              title: 'made_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '제조일자', sub: '(YYYY-MM-DD의 형식으로 입력해주십시오.)' }),
            },
            {
              title: 'expire_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '유효일자', sub: '(YYYY-MM-DD의 형식으로 입력해주십시오.)' }),
            },
            {
              title: 'detail_desc',
              required: '',
              type: 'String',
              desc: '상품상세설명',
            },
            {
              title: 'brand',
              required: '',
              type: 'String',
              desc: '브랜드',
            },
            {
              title: 'model',
              required: '',
              type: 'String',
              desc: '모델명',
            },
            {
              title: 'maker',
              required: '',
              type: 'String',
              desc: '제조사',
            },
            {
              title: 'keywords',
              required: '',
              type: 'String[]',
              desc: apiParamDesc({
                title: '키워드',
                notes: ['키워드는 최대 40개 까지 등록가능하며, 쇼핑몰에 상품전송시 쇼핑몰에서 지원하는 입력 갯수만큼만 전송됩니다.'],
              }),
            },
            {
              title: 'sale_img1',
              required: '',
              type: 'String',
              desc: '기본이미지 URL',
            },
            {
              title: 'sale_img2',
              required: '',
              type: 'String',
              desc: '추가이미지 1 URL',
            },
            {
              title: 'sale_img3',
              required: '',
              type: 'String',
              desc: '추가이미지 2 URL',
            },
            {
              title: 'sale_img4',
              required: '',
              type: 'String',
              desc: '추가이미지 3 URL',
            },
            {
              title: 'sale_img5',
              required: '',
              type: 'String',
              desc: '추가이미지 4 URL',
            },
            {
              title: 'sale_img6',
              required: '',
              type: 'String',
              desc: '추가이미지 5 URL',
            },
            {
              title: 'sale_img7',
              required: '',
              type: 'String',
              desc: '추가이미지 6 URL',
            },
            {
              title: 'sale_img8',
              required: '',
              type: 'String',
              desc: '추가이미지 7 URL',
            },
            {
              title: 'sale_img9',
              required: '',
              type: 'String',
              desc: '추가이미지 8 URL',
            },
            {
              title: 'sale_img10',
              required: '',
              type: 'String',
              desc: '추가이미지 9 URL',
            },
            {
              title: 'sale_img11',
              required: '',
              type: 'String',
              desc: '추가이미지 10 URL',
            },
            {
              title: 'prod_info',
              required: '',
              type: 'Object[]',
              desc: apiParamDesc({
                title: '품목정보고시',
                notes: [
                  '품목정보고시정보는 3개까지 입력가능합니다.',
                  '아래의 등록가이드를 참고해주세요.',
                  '<a href="https://gmp-master.s3.ap-northeast-2.amazonaws.com/download/Sample_prodInfo_guide_OPENAPI.xlsx" style="color: blue">상품 품목정보고시 가이드 개정판</a>',
                ],
              }),
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품분류코드',
                sub: '품목정보고시 입력 시 필수 입니다.',
                notes: [
                  '대표SKU상품 정보를 사용하고 싶으신경우 \'대표SKU상품\'으로 입력합니다.',
                  '대표SKU상품으로 입력시 아래의 정보는 입력할 필요가 없습니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'object',
              desc: apiParamDesc({
                title: '상품 정보 제공고시 데이터',
                notes: ['품목 정보고시 가이드에 기재된 각 항목에 따른 key와 value를 입력합니다.'],
              }),
              indent: 1,
            },
            {
              title: 'is_desc_referred',
              type: 'boolean',
              desc: apiParamDesc({
                title: '상품 정보 제공고시 데이터 일괄 [상세설명참조] 적용',
                notes: ['해당 값을 <code>true</code> 로 설정 시 입력한 값과 상관 없이 일괄 <code>[상세설명참조]</code>로 적용됩니다.'],
              }),
              indent: 1,
            },
            {
              title: 'ship_price_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '배송방법', allowedValues: ['무료', '선결제', '착불'] }),
            },
            {
              title: 'ship_price',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '배송비', notes: ['배송방법이 무료가 아닌경우 필수입니다.'] }),
            },
            {
              title: 'gift_name',
              required: '',
              type: 'String',
              desc: '사은품',
            },
            {
              title: 'supply_price',
              required: '',
              type: 'Number',
              desc: '공급가',
            },
            {
              title: 'cost_price',
              required: '',
              type: 'Number',
              desc: '원가',
            },
            {
              title: 'street_price',
              required: '',
              type: 'Number',
              desc: '시중가',
            },
            {
              title: 'global_barcode_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: 'UPC/EAN 타입', allowedValues: ['UPC', 'EAN'] }),
            },
            {
              title: 'global_barcode',
              required: '',
              type: 'Number',
              desc: 'UPC/EAN 코드',
            },
            {
              title: 'isbn',
              required: '',
              type: 'Number',
              desc: 'ISBN 코드',
            },
            {
              title: 'barcode',
              required: '',
              type: 'String',
              desc: '바코드',
            },
            {
              title: 'hscd',
              required: '',
              type: 'String',
              desc: 'HS코드',
            },
            {
              title: 'prod_weight',
              required: '',
              type: 'Number',
              desc: '상품무게',
            },
            {
              title: 'cert_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '인증정보타입',
                defaultValue: '인증대상아님',
                allowedValues: ['인증유형등록', '인증대상아님', '상세설명내등록'],
              }),
            },
            {
              title: 'certs',
              required: '',
              type: 'Array',
              desc: apiParamDesc({
                title: '인증정보',
                notes: ['인증정보는 10개까지 등록가능합니다.', '인증정보타입이 인증유형등록인 경우 필수로 입력해주셔야합니다.'],
              }),
            },
            {
              title: 'cert_cd',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '인증유형',
                notes: [
                  'cert_01: 생활용품 안전인증',
                  'cert_02: 생활용품 안전확인',
                  'cert_03: 생활용품 어린이보호포장',
                  'cert_04: 생활용품 안전품질표시',
                  'cert_05: 생활용품 공급자적합성확인',
                  'cert_06: 전기용품 안전인증',
                  'cert_07: 전기용품 안전확인',
                  'cert_08: 전기용품 공급자적합성확인',
                  'cert_09: 방송통신용품 적합성인증확인',
                  'cert_10: 어린이제품 안전인증',
                  'cert_11: 어린이제품 안전확인',
                  'cert_12: 어린이제품 공급자적합성확인',
                  'cert_13: 위해우려제품 자가검사',
                  'cert_14: 방송통신기자재 잠정인증',
                  'cert_15: 방송통신기자재 적합등록',
                  'cert_16: 원산지증명',
                  'cert_17: 해외안전인증',
                  'cert_18: 수입신고필증',
                  'cert_19: 친환경인증-무농약농산물',
                  'cert_20: 친환경인증-유기축산물',
                  'cert_21: 친환경인증-유기농산물',
                  'cert_22: 친환경인증-저농약농산물',
                  'cert_23: 친환경인증-무항생제축산물',
                  'cert_24: HACCP(위해요소 중점관리우수식품)',
                  'cert_25: GMP(우수건강기능식품 제조기준)',
                  'cert_26: GAP(농산물우수관리인증)',
                  'cert_27: 농산물이력추적관리',
                  'cert_28: 수산물품질인증',
                  'cert_29: 수산특산물품질인증',
                  'cert_30: 수산전통식품품질인증',
                  'cert_31: 친환경수산물품질인증',
                  'cert_32: 친환경수산가공품품질인증',
                  'cert_33: 전통식품 품질인증',
                  'cert_34: 유기가공식품 인증',
                  'cert_35: 가공식품 산업표준 KS인증',
                  'cert_36: 건강기능식품 광고사전심의',
                  'cert_37: 의료기기 광고사전심의',
                  'cert_38: 축산물 등급판정 확인서',
                  'cert_39: 도축검사증명서',
                  'cert_40: 식품명인(Grand master) 인증',
                  'cert_41: 사회적기업 인증',
                  'cert_42: 6차산업 인증',
                  'cert_43: 동물복지 인증',
                  'cert_44: 마을기업 인증',
                  'cert_45: 건강기능식품인증',
                  'cert_46: 생활화학제품',
                ],
              }),
              indent: 1,
            },
            {
              title: 'cert_exc_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '면제유형',
                allowedValues: ['kc_01', 'kc_02', 'kc_03'],
                notes: ['kc_01: 안전기준준수대상', 'kc_02: 구매대행', 'kc_03: 병행수입'],
              }),
              indent: 1,
            },
            {
              title: 'cert_ministry',
              required: '',
              type: 'String',
              desc: '인증기관',
              indent: 1,
            },
            {
              title: 'cert_no',
              required: '',
              type: 'String',
              desc: '인증번호',
              indent: 1,
            },
            {
              title: 'cert_model',
              required: '',
              type: 'String',
              desc: '인증모델',
              indent: 1,
            },
            {
              title: 'cert_cname',
              required: '',
              type: 'String',
              desc: '인증상호',
              indent: 1,
            },
            {
              title: 'cert_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '인증일', notes: ['YYYY-MM-DD의 날짜형식으로 입력해주십시오.'] }),
              indent: 1,
            },
            {
              title: 'cert_expire_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '인증만료일', notes: ['YYYY-MM-DD의 날짜형식으로 입력해주십시오.'] }),
              indent: 1,
            },
            {
              title: 'set_info',
              required: '',
              type: 'Object',
              desc: (
                <div>
                  등록 상품이 쇼핑몰 29CM인 경우만 상세 설명 이미지
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>객체의 키 값은 쇼핑몰 코드</li>
                    <li>
                      상세 설명 이미지가 하나 이상은 반드시 존재해야 됩니다.
                    </li>
                    <li>
                      [image_type]
                      <ul className='style' style={{ color: 'gray' }}>
                        <li>4: 기본 타입</li> <li>5: 영상 타입</li>
                        <li>6: 타이틀 구분 타입</li>
                        <li>7: 이미지 링크 타입</li>
                      </ul>
                    </li>
                  </ul>
                  <pre>
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>"image_info"</span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='pun'>[</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'    {'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>&nbsp;&nbsp;&nbsp;&nbsp;"title"</span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"타이틀"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"content"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"설명"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>4</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'}'},</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>&nbsp;&nbsp;&nbsp;&nbsp;"title"</span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"타이틀"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"content"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"설명"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"added_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"VIDEO_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"added_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>1</span>
                    <span className='pun'>,</span>
                    <span className='pln'> </span>
                    <span className='com'> # 1: 유튜브, 2: 비메오 </span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>5</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'}'},</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>&nbsp;&nbsp;&nbsp;&nbsp;"title"</span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"타이틀"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='pun'>[</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'        {'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"content"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"설명"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_URL"</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'        }'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>&nbsp;&nbsp;&nbsp;&nbsp;],</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"is_layout"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"F"</span>
                    <span className='pun'>,</span>
                    <span className='pln'> </span>
                    <span className='com'>
                      {' '}
                      # "F": 레이아웃 1단, "T": 레이아웃 2단
                    </span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>6</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'}'},</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"added_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_LINK_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_url"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='str'>"IMG_URL"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='str'>
                      &nbsp;&nbsp;&nbsp;&nbsp;"image_type"
                    </span>
                    <span className='pun'>:</span>
                    <span className='pln'> </span>
                    <span className='lit'>7</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pln'> </span>
                    <span className='pun'>{'    }'}</span>
                    <br />
                    <span className='pln'> </span>
                    <span className='pun'>{'}'}</span>
                    <span className='pln'> </span>
                  </pre>
                </div>
              ),
            },
          ],
          body_example: {
            c_sale_cd: 'm20200928724997',
            sol_cate_no: 85036,
            shop_sale_name: 'api 테스트 상품 수정',
            adult_yn: true,
            sale_price: 50000,
            sale_cnt_limit: 88,
            shop_cd: 'A112',
            shop_id: 'playauto',
            keywords: ['test', 'test1'],
            edit_slave_all: true,
            std_ol_yn: 'N',
            opt_type: '조합형',
            unit_price_yn: true,
            unit_capacity: 100,
            indication_unit: 'ml',
            unit_price_type: '낱개',
            unit_price_pack_qty: 1,
            unit_price_item_qty: 1,
            unit_price_item_qty_unit: '개',
            item_capacity: 500,
            opts: [
              {
                opt_sort1: '색상',
                opt_sort2: '사이즈',
                opt_sort3: '',
                opt_sort4: '',
                opt_sort5: '',
                opt_sort1_desc: '빨강',
                opt_sort2_desc: '큼',
                opt_sort3_desc: '',
                opt_sort4_desc: '',
                opt_sort5_desc: '',
                opt_custom_cd: 'OPT_RED_01',
                model_no: 'MDL-RED-01',
                barcode: 'BAR-RED-01',
                sku_cd: 'S999C90F18A4',
                pack_unit: 1,
                add_price: 0,
                stock_cnt: 99,
                weight: 0.5,
                status: '정상',
                unit_price_yn: true,
                unit_capacity: 50,
                indication_unit: 'g',
                unit_price_type: '팩',
                unit_price_pack_qty: 2,
                unit_price_item_qty: 5,
                unit_price_item_qty_unit: '개',
                item_capacity: 10,
              },
              {
                opt_sort1: '색상',
                opt_sort2: '사이즈',
                opt_sort3: '',
                opt_sort4: '',
                opt_sort5: '',
                opt_sort1_desc: '파랑',
                opt_sort2_desc: '큼',
                opt_sort3_desc: '',
                opt_sort4_desc: '',
                opt_sort5_desc: '',
                opt_custom_cd: 'OPT_BLUE_01',
                model_no: 'MDL-BLUE-01',
                barcode: 'BAR-BLUE-01',
                sku_cd: 'S999C47FACA0',
                pack_unit: 1,
                add_price: 5000,
                stock_cnt: 88,
                weight: '1',
                status: '품절',
                unit_price_yn: false,
              },
            ],
            input_name: ['입력형옵션1', '입력형옵션2'],
            add_opts: [
              {
                opt_sort: '추가구매타입',
                opt_sort_desc: '추가구매1',
                opt_custom_cd: 'ADD_OPT_01',
                model_no: 'MDL-01',
                barcode: 'BAR-01',
                price: 1000,
                stock_cnt: 20,
                sku_cd: 'S893688C1788',
                pack_unit: 2,
                weight: 0,
                status: '정상',
              },
              {
                opt_sort: '추가구매타입',
                opt_sort_desc: '추가구매2',
                opt_custom_cd: 'ADD_OPT_02',
                model_no: 'MDL-02',
                barcode: 'BAR-02',
                price: 2000,
                stock_cnt: 30,
                sku_cd: 'S1880FB95EB1',
                pack_unit: 1,
                weight: 1,
                status: '품절',
              },
            ],
            tax_type: '과세',
            madein: {
              madein_no: 2,
              madein_etc: '',
              multi_yn: false,
            },
            made_date: '2020-01-01',
            expire_date: '2021-03-01',
            detail_desc: '상세설명',
            brand: '브랜드',
            model: '모델명',
            maker: '제조사',
            sale_img1: 'https://sample.com/productImage.jpg',
            prod_info: [
              {
                infoCode: 'Wear2023',
                infoDetail: {
                  material: '1',
                  color: '2',
                  size: '3',
                  manufacturer: '4',
                  made_in: '5',
                  caution: '6',
                  release: '7',
                  warranty: '8',
                  customer_service: '9',
                },
              },
              {
                infoCode: 'Shoes2023',
                infoDetail: {
                  material: '1',
                  color: '2',
                  size: '3',
                  manufacturer: '4',
                  made_in: '5',
                  caution: '6',
                  warranty: '7',
                  customer_service: '8',
                },
              },
            ],
            add_desc_info: {
              image_info: [
                {
                  title: '타이틀',
                  content: '설명',
                  image_url: 'IMG_URL',
                  image_type: 4,
                },
              ],
            },
          },

          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공/실패',
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String',
              desc: '등록된 상품의 판매자관리코드',
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '등록이 실패된경우 에러 메세지',
            },
          ],
          response_example: {
            status: true,
            c_sale_cd: 'm20200925497324',
            message: '',
          },
        },
      ],
    },
  ];
};

export default getV12APIs;
